//Invoices and Spoilage
import React, { Component } from 'react'
import "../css/general-style.css"
import '../css/table-responsive.css'
import '../css/invoicev3-style.css'
import LoadingWindow from '../components/LoadingWindow';
import { AiFillPrinter } from "react-icons/ai";
import { FiTrash, FiCheckCircle, FiAlertTriangle, FiXCircle, FiHelpCircle } from "react-icons/fi";
import CustomerList from '../components/CustomerList';
import Select from 'react-select';
import { getValueCookie } from '../services/cookieService';
import { create_Delete_Update_Information, getInformationWithData, getInformationWithDataV3, getInformationWithDataGlobalSales, saveJsonData } from '../services/CABE';
import Swal from "sweetalert2";

import SmallModal from '../components/SmallModal';
import { DateFormatMAS90, FormatQueryReturnDateForReport, getActualDateUTC, getDateYearMonthDayDash } from '../functions/dateFormat';
import { OrderPDF } from '../components/OrderPDF';
import { pricesFormat } from '../functions/pricesFormat';
import { getPrintHeaderCompany } from '../functions/companyInformation';
import { getIndexElement } from '../functions/searchInObject';
import InvoiceListSalesPerson from '../components/InvoiceListSalesPerson';
import InvoiceListCustomerNo from '../components/InvoiceListCustomerNo';
import { InvoicePDFInvoiceV3 } from '../components/InvoicePDFInvoiceV3';
import { confirmCloseAlert } from '../functions/alerts';
import SalesOrderPicking from '../components/SalesOrderPicking';
import { DecimalPart, MobileDisp, NumberFormat, OrderArray, validateNumbersForQuantitys, getInvoiceV3PriceMargin } from '../functions/generalFunctions';
import SearchUPC from '../components/SearchUPC';
import { InvoicePDF2InvoiceV3 } from '../components/InvoicePDF2InvoiceV3';
import CatalogueV3Invoice from './CatalogueV3Invoice';
import { InvoiceZebra } from '../components/InvoiceZebra/InvoiceZebra';
import { DownloadInvoicePDFInvoiceV3 } from '../components/DownloadInvoicePDFInvoiceV3';
import { DownloadInvoicePDF2InvoiceV3 } from '../components/DownloadInvoicePDF2InvoiceV3';
import ShippingAddress from '../components/ShippingAddress/ShippingAddress';

// Temporal check if theres a blocked item
import { blockedItems } from '../components/Catalogue2.0/blockedItems'

// MEJORA 1 — generic server-health gate (ensureServerHealthyBeforeLoad
// below), unrelated to pricing — kept as-is. The old MEJORA 2 price
// validation that also lived on ensureServerHealthy/notifyIT/
// clearServerCheckCache was replaced (2026-08-20) by the standardized
// pricing/map floor — see priceValidation() and buildInvoiceCartLine.js.
import { ensureServerHealthy } from '../functions/serverConnectionCheck'

// Menu
import { Menu } from "../components/Menu/Menu";

let includedItems = [];

// 2026-09-09 (client's ask) — "never lose an invoice" post-save check
// (validateAndOpenPrint()/checkInvoicePersistedCorrectly()). Rollback
// switch: set to false to fully disable it — Save and Print goes straight
// back to the exact pre-2026-09-09 behavior (OpenPrint(mode) called
// immediately after a successful /invoice/set, no 5s wait, no
// header/detail check, no error message). No other line needs to change.
const ENABLE_INVOICE_PERSISTENCE_CHECK = true;

export default class Invoices extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
        // MEJORA 2 — lets the price-validation "Retry" flow re-invoke
        // SalesOrderPicking's own SelectOrderDetail() to fully reload the
        // Sales Order, instead of duplicating its item-mapping logic here.
        this.SalesOrderPickingRef = React.createRef();
        // Same idea, for the "Invoice list" (non-history) loader.
        this.InvoiceListSalesPersonRef = React.createRef();
    }


    state = {
        Invoice: {
            InvoiceNo: '',
            InvoiceDate: '',
            BatchNo: '',
            InvoiceType: 'IN',
            Warehouse: '000',
            SalespersonNo: '',
            Comment: '',
            FreightAmt: 0,
            Customer: {
                AddressLine1: '',
                City: '',
                CountryCode: '',
                CreditLimit: 0,
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                FaxNo: '',
                PriceLevel: '',
                SalespersonNo: '',
                State: '',
                TelephoneNo: '',
                TermsCode: '',
                UDF_RUTA: '',
                ZipCode: '',
                TaxSchedule: 'NONTAX',
            },
            TotalQuantityOrdered: 0,
            TotalCost: 0,
            TotalQuantityShipped: 0,
            TotalWeight: 0,
            SalesOrderNo: '',
            ApplyToInvoiceNo: '',
            Duplicate: false,
            ShipToName: '',
            ShipToAddress1: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipCode: ''
        },
        Products: [],
        Balance: {
            HeaderBalance: [],
            TermsCode: '',
            TotalBalance: 0,
            SelectedInvoice: '',
            Detail: []
        },
        updatedPricesProducts: [],
        companyPrintHeader: getPrintHeaderCompany(),
        showModal1: false,
        showModal2: false,
        selectOptions1: [
            { value: 'IN', label: 'Standard' },
            { value: 'CM', label: 'Credit Memo' }
        ],
        selectOptions2: [
            { value: '003', label: 'B&B Miami Warehouse Price Level 4' },//4
            { value: '000', label: 'Mayaland Atlanta Warehouse Price Level 3' }//5
        ],
        temporalBatchNo: '',
        oldInvoice: false,
        enablePrint: true,
        addTitle: '',
        PercentageScanning: 0,
        PercentageManual: 0,
        TotalManual: 0,
        TotalScanning: 0,
        isAlreadyInvoiced: false,
        invoiceNoGenerated: false,
        // 2026-08-25 — tracks whether the current Sales Order price
        // integrity check (validateSalesOrderPriceIntegrity()) is running as
        // a retry (its own automatic reload) or the first attempt — see that
        // method's comment for the full flow.
        isRetryingSalesOrderPriceCheck: false,
        // 2026-08-25 — set by loadPricingMap() when /v3/pricing/map itself
        // failed (bad status/shape), as opposed to succeeding with simply no
        // rows configured. Read by validateSalesOrderPriceIntegrity().
        pricingMapLoadFailed: false,
        // Tracks why the "New Batch Number" modal (showModal1) was opened,
        // so ConfirmBatchNumber() knows whether it's safe to keep the
        // InvoiceNo/Products already assigned (Sales Order load) or whether
        // it should regenerate everything (New Invoice button — its
        // original, unchanged behavior).
        batchNumberContext: 'newInvoice',
        // Standardized pricing (2026-08-20 project, replaces the old MEJORA 2
        // /v2/Items/get catalog-cost comparison) — itemCode -> {cost,
        // standardPrice, minPrice, maxPrice, level1Price}, mirrors
        // SalesOrderV3.js's pricingMap. Applies to BOTH companies (Mayaland
        // and Altitude), unlike the old MEJORA 2 flow which was Altitude-only.
        pricingMap: {},
        pricingLoaded: false,
        // CM price ceiling (2026-09-02, client's ask) — itemCode -> UnitPrice,
        // the price that item had on the invoice being credited. Populated
        // by InvoiceListCustomerNo.js (opt-in via its loadPriceCeilings
        // prop, only passed here) when "Select Invoice to Apply" is used —
        // see classifyProducts()/applyCreditMemoPriceCeiling()/
        // checkCreditMemoPriceCeiling(). Empty/unused outside a CM.
        cmPriceCeilings: {},
        customerPriceLevel: 1,
        customerShippingAddresses: [],
        selectedShippingAddress: {},
        disabledShippingAddressStatus: false,
        AltitudeInvoiceComment: '',
        TruckingNumber: 0
    }

    handleModalOpen = (modal) => {

        this.setState({ [modal]: true })
    }

    handleModalClose = async (modal) => {
        if (modal === 'showModal1') {
            if (this.state.Invoice.BatchNo !== '' && this.state.Invoice.BatchNo !== null && this.state.Invoice.BatchNo !== undefined) {
                await this.StartNewInvoice()
                this.setState({ temporalBatchNo: '' })
                this.setState({ [modal]: false })
            }
        } else {
            this.setState({ [modal]: false })
        }
    }

    handleStorageChange = async (event) => {
        if (event.key === 'InvoiceSave') {
            let infoRec = JSON.parse(localStorage.getItem('InvoiceSave'));
            if (infoRec) {
                if (infoRec.Invoice.InvoiceNo === this.state.Invoice.InvoiceNo) {
                    await this.setState({ Products: infoRec.Products, Invoice: infoRec.Invoice })
                    await this.refreshInputs()
                }
            }
        }
    }

    async getNewCorrelativeBatchNumber() {

        const data = {
            type: 'BatchNumber',
            idCompany: getValueCookie('CompanyId')
        }
        const result = await getInformationWithData('/sales/get/correlativeV2', data)
        if (result.status.code === 1) {
            const temporal = "M" + result.data[0].correlative
            document.getElementById('batchNoInputInvoice').value = temporal
            this.setState({ temporalBatchNo: temporal })
        }
    }

    async getNewCorrelativeInvoiceNumber() {
        // MEJORA 1 — verify server health before requesting the correlative.
        // Non-blocking: proceeds regardless of the outcome either way (see
        // ensureServerHealthyBeforeLoad for why).
        //
        // TODO (MEJORA 1 — still pending, not built yet): if this resolves
        // unhealthy, we should instead:
        //   - show the "Offline mode" banner on this screen
        //   - set a placeholder InvoiceNo like `TEMP-${Date.now()}` instead of
        //     calling /sales/get/correlativeV2
        //   - swap the "Save and Print" button for a "Save temporal" button
        //     that POSTs to the (TODO) AWS pending-sync endpoint instead of the
        //     normal save flow
        // See functions/serverConnectionCheck.js for the shared check/cache.
        await this.ensureServerHealthyBeforeLoad('new_invoice');

        const data = {
            type: 'InvoiceNumber',
            idCompany: getValueCookie('CompanyId')
        }
        const result = await getInformationWithData('/sales/get/correlativeV2', data)
        if (result.status.code === 1) {
            const temporal = this.state.Invoice
            temporal.InvoiceNo = 'PM' + result.data[0].correlative
            // Pre-existing gap (not Mejora 2): this was the only caller of
            // /sales/get/correlativeV2 that never marked invoiceNoGenerated,
            // so ChangeSalesOrder() below kept re-generating a fresh InvoiceNo
            // every time a Sales Order was (re)selected instead of reusing
            // the one already assigned to the current draft.
            this.setState({ Invoice: temporal, invoiceNoGenerated: true })
        }
    }

    async ChangeSalesOrder() {
        // This flow only ever needs to ask for a BatchNo — the InvoiceNo
        // (just generated below) and the Products/Customer already loaded
        // from the Sales Order must NOT be touched by confirming it.
        this.setState({ batchNumberContext: 'salesOrder' })
        const salesPerson = getValueCookie('TypeUser') === '8'? '0000' : getValueCookie('SalesPerson');
        const data = {
            SalespersonNo: salesPerson,
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            CustomerNo: '*'
        }
        let respuesta = await getInformationWithData('/invoice/header', data);
        const index = getIndexElement(respuesta.data, 'InvoiceNo', this.state.Invoice.InvoiceNo)

        if (index === -1) {
            await this.getNewCorrelativeInvoiceNumber()
            const temporal = this.state.Invoice
            if (temporal.BatchNo === '') {
                this.handleModalOpen('showModal1')
            } else {
                Swal.fire({
                    title: 'Do you want change the Invoice Number and the Batch Number?',
                    showDenyButton: true,
                    confirmButtonText: 'Yes',
                    denyButtonText: `No`,
                    allowOutsideClick: false
                }).then(async (result) => {
                    if (result.isConfirmed) {

                        this.handleModalOpen('showModal1')
                        document.getElementById('batchNoInputInvoice').value = ''



                    }
                })
            }
        }
    }

    BatchNumberModal(moddle) {
        // "New Invoice" always wants a fresh InvoiceNo — original behavior.
        this.setState({ batchNumberContext: 'newInvoice' })

        if (this.state.Invoice.InvoiceType === 'IN') {
            this.clearAll()
        }

        const temporal = this.state.Invoice
        if (temporal.BatchNo === '' || temporal.BatchNo === null || temporal.BatchNo === undefined) {
            this.handleModalOpen('showModal1')
        } else {
            Swal.fire({
                title: 'Do you want change the Batch Number?',
                showDenyButton: true,
                confirmButtonText: 'Yes',
                denyButtonText: `No`,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.isConfirmed) {

                    this.handleModalOpen('showModal1')
                    document.getElementById('batchNoInputInvoice').value = ''



                } else if (result.isDenied) {
                    if (moddle === 'New') {
                        await this.StartNewInvoice()
                    }
                }
            })
        }
    }

    ConfirmBatchNumber() {
        const batchValue = document.getElementById('batchNoInputInvoice').value
        
        // Regex for only letters and numbers
        const alphanumericRegex = /^[a-zA-Z0-9]*$/;

        if(!alphanumericRegex.test(batchValue) || batchValue.trim() === ''){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Only letters and numbers are allowed! No space or special characters.',
            })
            return
        }

        const temporal = this.state.Invoice
        temporal.BatchNo = batchValue
        this.setState({ Invoice: temporal, temporalBatchNo: '' })

        if (this.state.batchNumberContext === 'salesOrder') {
            // Just came from loading a Sales Order — keep the InvoiceNo and
            // Products already assigned, only the BatchNo was missing.
            // Don't call StartNewInvoice(): it would wipe Products/Customer
            // and generate ANOTHER InvoiceNo via correlativeV2.
            this.setState({ showModal1: false })
        } else {
            this.StartNewInvoice()
            this.handleModalClose('showModal1')
        }
    }

    ConfirmBatchNumberOld() {
        const batchValue = document.getElementById('batchNoInputInvoice').value
        const temporal = this.state.Invoice
        temporal.BatchNo = batchValue
        this.setState({ Invoice: temporal })
        this.handleModalClose('showModal1')
    }

    async StartNewInvoice() {
        //funcion clear sin el batch
        if (!this.state.oldInvoice) {
            await this.clearAll()
        }

        await this.getNewCorrelativeInvoiceNumber()
        const temporal = this.state.Invoice
        temporal.InvoiceDate = getDateYearMonthDayDash()
        temporal.SalespersonNo = getValueCookie('SalesPerson')
        this.setState({ Invoice: temporal, invoiceNoGenerated: true })
    }
    async getDetailBalance(LineBalance) {
        const data = {
            idCompany: Number(getValueCookie('CompanyId')),
            InvoiceNo: LineBalance.InvoiceNo
        }
        this.ModalLoading.current.showState(true);
        const result = await getInformationWithData('/invoice/history/getInvoicePayment', data)
        if (result.status.code === 1) {
            const temporal = this.state.Balance
            temporal.Detail = result.data
            temporal.SelectedInvoice = LineBalance.InvoiceNo
            this.setState({ Balance: temporal })
        }
        this.ModalLoading.current.showState(false);
    }
    getTotalBalance() {
        let currentBalance = 0

        this.state.Balance.HeaderBalance.forEach(line => {
            currentBalance += Number(line.Balance)
        });

        const temporal = this.state.Balance
        temporal.TotalBalance = currentBalance
        this.setState({ Balance: temporal })
    }

    onTarget = async (e, item) => {

        const ident = e.target.id.split('_')
        if (ident.length === 1) {
            const temporal = this.state.Invoice
            if (ident[0] === 'FreightAmtInvoice') {
                temporal.FreightAmt = Number(e.target.value)
                this.setState({ Invoice: temporal })
            } else if (ident[0] === 'CarrierInvoice') {
                temporal.Comment = e.target.value
                this.setState({ Invoice: temporal })
            } else if (ident[0] === 'batchNoInputInvoice') {
                this.setState({ temporalBatchNo: e.target.value })
            }
        } else {
            const temporal = this.state.Products
            const index = temporal.indexOf(item)

            if (index !== -1) {
                if (ident[0] === "quantityShippedInvoice") {
                    let quant = Number(e.target.value)

                    if (!validateNumbersForQuantitys(quant)) {
                        let parteDecimal = 1 - DecimalPart(quant)
                        quant += parteDecimal
                        document.getElementById(e.target.id).value = quant
                    }


                    temporal[index].quantityShipped = Number(quant)
                    temporal[index].totalCost = (Number(quant) * Number(temporal[index].UnitPrice))
                    temporal[index].totalWeight = (Number(quant) * Number(temporal[index].ShipWeight))
                    // MEJORA 2 — a qty edit changes whether this line counts
                    // toward the invoice total (and can therefore block
                    // Save/Print); the color itself doesn't depend on qty.
                    temporal[index].PriceStatus = this.recomputePriceStatus(temporal[index])
                    temporal[index].AffectsInvoiceTotal = this.recomputeAffectsInvoiceTotal(temporal[index])
                    this.setState({ Products: temporal })
                    this.calculateTotals(temporal)
                } else if (ident[0] === "unitPriceInvoice") {
                    const updatedProducts = this.state.Products.map(p => {
                        if (p.itemCode === item.itemCode) {
                            const newPrice = Number(e.target.value);
                            const updated = {
                                ...p,
                                UnitPrice: newPrice,
                                totalCost: newPrice * Number(p.quantityShipped)
                            };
                            // MEJORA 2 — reclassify this row live as the price changes.
                            updated.PriceStatus = this.recomputePriceStatus(updated)
                            updated.AffectsInvoiceTotal = this.recomputeAffectsInvoiceTotal(updated)
                            return updated;
                        }
                        return p;
                    });

                    this.setState({ Products: updatedProducts });
                    this.calculateTotals(updatedProducts);
                    // temporal[index].UnitPrice = Number(e.target.value)
                    // temporal[index].totalCost = (Number(e.target.value) * Number(temporal[index].quantityShipped))
                    // this.setState({ Products: temporal })
                    // this.calculateTotals()
                }


            }
        }
    }

    /**
     * allowBelowCost only actually applies for price level 3/4 customers
     * (2026-08-27, client's ask) — level 1/2 never get this exception,
     * regardless of what value the flag itself carries (0 or 1). Matches
     * ProductPricing.js's own admin model: allowLevel3BelowCost and
     * allowLevel4BelowCost are two SEPARATE checkboxes, one per tier — there
     * is no "allowLevel1BelowCost"/"allowLevel2BelowCost" concept at all, so
     * a level 1/2 customer's resolved allowBelowCost value (however it got
     * set) is meaningless and must be ignored. customerPriceLevel comes
     * from the same /v3/pricing/map response (see loadPricingMap()) as the
     * item's own pricing fields, so it's always in sync with them.
     */
    itemAllowsBelowCost(item) {
        const priceLevel = this.state.customerPriceLevel
        return !!(item && item.allowBelowCost) && (priceLevel === 3 || priceLevel === 4)
    }

    /**
     * Below-minimum exception (migration 017/019, ported from
     * SalesOrderV3.js's priceFloorFor()) — shared by
     * checkInvoicePriceFloor() and recomputePriceStatus(), so both always
     * agree on the same floor.
     *
     * Client-side branching RESTORED (2026-08-27, second pass) — a
     * teammate's merge briefly simplified this to always `return
     * item.minPrice`, on the assumption that /v3/pricing/map's minPrice was
     * already fully resolved server-side (normal minimum vs. the
     * allowBelowCost exception). Confirmed broken in practice: adding a
     * product from the catalog (buildInvoiceCartLine.js -> CatalogueV3Invoice.js,
     * re-classified against pricingMap via classifyProducts()) still ignored
     * allowBelowCost entirely, because nothing downstream of priceFloorFor()
     * ever looks at that flag anymore once it just echoes minPrice. Per the
     * client's own explicit call on this (2026-08-27): when the exception
     * actually applies (see itemAllowsBelowCost() — level 3/4 only), the
     * floor is costAtSale AS-IS — no extra *1.05 math needed, company 6's
     * cost already carries its 5% and company 3 should work the same way
     * with its own cost. Mirrors the same branch already used in
     * validateSalesOrderPriceIntegrity(). No fallback to level1Price
     * (2026-08-20 Invoice-specific fix — see checkInvoicePriceFloor()'s own
     * comment).
     */
    priceFloorFor(item) {
        if (this.itemAllowsBelowCost(item) && item.costAtSale !== undefined && item.costAtSale !== null) {
            return item.costAtSale
        }
        return item.minPrice
    }

    /**
     * Standardized pricing (2026-08-20) — hard price floor. The VIOLATION
     * check is against priceFloorFor() (minPrice, or costAtSale when
     * allowBelowCost applies — see that method's own comment) — no fallback
     * to level1Price
     * (2026-08-20 fix — a fallback silently enforced the wrong number for
     * lines whose minPrice hadn't resolved yet). If no floor is configured
     * for this item, nothing is enforced on it rather than silently
     * enforcing an unrelated price. Applies to everyone including admin,
     * both companies, no bypass — "never lose money". Wired to onBlur (not
     * onChange, which stays on onTarget above for live red/amber feedback
     * while typing) so it doesn't fight the user mid-keystroke.
     *
     * The REPLACEMENT value (2026-08-20, corrected) is standardPriceAtSale,
     * not the floor itself — going below the floor resets the field to the
     * item's normal standard price, not down to the bare minimum/cost, so
     * the line doesn't silently end up parked at zero margin. Falls back to
     * the floor itself only if standardPriceAtSale somehow isn't cached on
     * this line.
     */
    checkInvoicePriceFloor = (e, item) => {
        const index = this.state.Products.findIndex(p => p.itemCode === item.itemCode)
        if (index === -1) return
        const product = this.state.Products[index]
        const newPrice = Number(e.target.value)
        const min = this.priceFloorFor(product)

        if (min === undefined || min === null) return

        // 2026-08-27 (client's ask) — exactly AT the floor is only allowed
        // for the NORMAL minPrice floor (documented 2026-08-20 fix, still
        // true there). When the allowBelowCost exception is what's actually
        // setting the floor (priceFloorFor() returned costAtSale), the
        // floor is strict — a price sitting exactly at cost never leaves
        // any margin at all, so it's a violation too, not just going below it.
        const isCostFloor = this.itemAllowsBelowCost(product) && product.costAtSale !== undefined && product.costAtSale !== null
        const violatesFloor = isCostFloor ? newPrice <= min : newPrice < min
        if (!violatesFloor) return

        const replacement = (product.standardPriceAtSale !== undefined && product.standardPriceAtSale !== null) ? product.standardPriceAtSale : min
        const clamped = Number(replacement.toFixed(2))
        const inputId = e.target.id
        const updatedProducts = this.state.Products.map(p => {
            if (p.itemCode !== item.itemCode) return p
            const updated = { ...p, UnitPrice: clamped, totalCost: clamped * Number(p.quantityShipped) }
            updated.PriceStatus = this.recomputePriceStatus(updated)
            updated.AffectsInvoiceTotal = this.recomputeAffectsInvoiceTotal(updated)
            return updated
        })

        this.setState({ Products: updatedProducts }, () => {
            const el = document.getElementById(inputId)
            if (el) el.value = clamped.toFixed(2)
            this.calculateTotals()
        })
        alert(`${this.itemAllowsBelowCost(product) ? 'The minimum (special pricing)' : 'The minimum price'} for this product is bellow from the standard price`)
    }

    onChangeSelects = async (e, id) => {
        if (id === 'Type') {
            await this.clearAll()
        }
        const temporal = this.state.Invoice
        switch (id) {
            case "Type":
                temporal.InvoiceType = e.value
                this.setState({ Invoice: temporal })
                break;
            case "Warehouse":
                temporal.Warehouse = e.value
                this.setState({ Invoice: temporal })
                this.changePriceLevel(e.value)
                break;
            default:
                break;
        }


    }
    changePriceLevel(id) {
        const temporal = this.state.Invoice
        switch (id) {
            case "003":
                temporal.Customer.PriceLevel = '4'
                this.setState({ Invoice: temporal })
                break;
            case "000":
                temporal.Customer.PriceLevel = '3'
                this.setState({ Invoice: temporal })
                break;

            default:
                break;
        }
    }


    calculateTotals(products = []) {
        let totalQuantity = 0
        let totalCost = 0
        let totalShipped = 0
        let totalWeight = 0
        const temporal = this.state.Products
        const temporal2 = this.state.Invoice
        const priceMarginProducts = products.length > 0 ? products : temporal;
        const priceMargin = getInvoiceV3PriceMargin(priceMarginProducts);

        for (const item of temporal) {

            totalQuantity += Number(item.quantityOrdered)
            totalCost += Number(pricesFormat(item.totalCost))
            totalShipped += Number(item.quantityShipped)
            totalWeight += Number(item.totalWeight)

        }
        temporal2.TotalQuantityOrdered = totalQuantity
        temporal2.TotalQuantityShipped = totalShipped
        temporal2.TotalWeight = totalWeight
        temporal2.TotalCost = totalCost.toFixed(2)
        this.setState({ Invoice: temporal2, TruckingNumber: priceMargin })
        this.AutoSave()
    }
    removeProduct(item) {
        const temporal = this.state.Products
        const index = temporal.indexOf(item)
        if (index !== -1) {
            temporal[index].quantityShipped = 0
            temporal[index].totalCost = 0
            temporal[index].Visible = 0
            temporal[index].totalWeight = 0
            for (let a = 0; a < temporal.length; a++) {
                document.getElementById("quantityShippedInvoice_" + a).value = temporal[a].quantityShipped
                // .toFixed(2) (2026-08-20, same fix as SalesOrderV3.js) —
                // writing the raw number here (e.g. 12.5) showed 1 decimal
                // instead of 2, since this input is uncontrolled and nothing
                // else re-formats it after this direct DOM write.
                document.getElementById("unitPriceInvoice_" + a).value = Number(temporal[a].UnitPrice).toFixed(2)
            }
            this.setState({ Products: temporal })
            this.calculateTotals()
        }
        // Remove from the advice message
        includedItems = includedItems.filter(product => product !== item)
    }

    AsignLineSequence() {

        const temporal = OrderArray(JSON.parse(JSON.stringify(this.state.Products)), 'IdCompany', true)


        let count = 1
        for (const item of temporal) {

            let flag = false
            item.LineKey = count
            if ((!(this.state.Invoice.SalesOrderNo))) {
                flag = true
            }
            if (this.state.Invoice.SalesOrderNo === '') {
                flag = true
            }
            if (flag) {


                if (item.Comment !== null && item.Comment !== undefined) {
                    let t = item.Comment.split('||')
                    if (t.length >= 3) {
                        item.Comment = t[0] + "||" + item.RegisterType + "||" + getValueCookie('userName') + "||" + (item.HaveUPC ? '1' : '0')
                    } else {
                        item.Comment += "||" + item.RegisterType + "||" + getValueCookie('userName') + "||" + (item.HaveUPC ? '1' : '0')
                    }


                }
                if (item.RegisterType) {

                }
            }

            count++
        }

        this.setState({ Products: temporal })
        this.calculatePercentageScanning()



    }

    calculatePercentageScanning() {
        const total = this.state.Products.length
        if (total > 0) {
            let realTotal = 0
            let manual = 0
            let scanner = 0
            for (const item of this.state.Products) {
                if (item.Visible === 1) {
                    realTotal++
                    if (item.RegisterType === 's' || (item.quantityShipped > 0 && !item.HaveUPC)) {
                        scanner += 1
                    } else if (item.RegisterType === 'm') {
                        manual += 1
                    }
                }

            }

            let Pmanual = 100 * (manual / realTotal)
            let Pscanning = 100 * (scanner / realTotal)

            this.setState({ TotalManual: manual, TotalScanning: scanner, PercentageManual: Pmanual, PercentageScanning: Pscanning })
        } else {
            this.setState({ TotalManual: 0, TotalScanning: 0, PercentageManual: 0, PercentageScanning: 0 })
        }
    }

    // compareProductPrices(){
    //     const {Products, updatedPricesProducts} = this.state;
    // }

    SecurityPrices() {

        for (const item of this.state.Products) {
            if (Number(item.UnitPrice) === 0) {
                return true
            }
        }
        return false
    }


    /**
     * Duplicate-line validation on LOAD (2026-08-20, ported from
     * SalesOrderV3.js's removeDuplicateProducts/validateNoDuplicateProducts)
     * — removes duplicate itemCode rows from a Products array, keeping the
     * FIRST occurrence and dropping the rest. Any duplicate here is a bug
     * artifact from the load itself (e.g. /sales/get/detail or
     * /invoice/get/detail returning the same item twice), never a
     * legitimate second line — same reasoning as SalesOrderV3.js. Does NOT
     * merge quantities, only deletes.
     */
    removeDuplicateProducts(products) {
        const seen = new Set()
        const removedCodes = []
        const cleaned = []
        for (const item of products) {
            if (seen.has(item.itemCode)) {
                removedCodes.push(item.itemCode)
                continue
            }
            seen.add(item.itemCode)
            cleaned.push(item)
        }
        return { cleaned, removedCodes }
    }

    /** Runs removeDuplicateProducts and, if it found anything, warns + alerts the user. */
    validateNoDuplicateProducts(products) {
        const { cleaned, removedCodes } = this.removeDuplicateProducts(products)
        if (removedCodes.length > 0) {
            console.warn('[InvoiceV3] Duplicate line items removed:', removedCodes)
            confirmCloseAlert('incorrect', `Se detectaron productos duplicados y se eliminó la fila repetida de: ${removedCodes.join(', ')}. Se conservó la primera fila de cada uno.`)
        }
        return cleaned
    }

    /**
     * Shared onOrderLoaded handler for both SalesOrderPicking and
     * InvoiceListSalesPerson (2026-08-20) — by the time onOrderLoaded fires,
     * the child component has already pushed the loaded lines into
     * this.state.Products, so dedupe runs against fresh state before
     * priceValidation() classifies what's left. priceValidation() itself
     * goes through ensurePricingMapLoaded(), which shares the single
     * in-flight fetch with componentDidUpdate — see that method's comment
     * for why this is the actual fix (a previous version here re-verified
     * with an extra retry pass instead of removing the duplicate fetch;
     * that made the race worse, not better — removed 2026-08-20).
     */
    afterOrderLoaded = async () => {
        const cleaned = this.validateNoDuplicateProducts(this.state.Products)
        await new Promise((resolve) => this.setState({ Products: cleaned }, resolve))
        await this.priceValidation()
    }

    // ============================================================
    // 2026-08-25 — Sales Order price-integrity "last lock" (SalesOrderPicking
    // / "Sales Order list" button ONLY — the Invoice list flow above still
    // uses the plain afterOrderLoaded() untouched, and Credit Memos are
    // explicitly skipped in validateSalesOrderPriceIntegrity() below, same
    // guard priceValidation() already uses for them).
    //
    // Investigated: a normal customer's Sales Order sometimes shows up in
    // this table with a UnitPrice different from what the Sales Order
    // actually has. Traced every place that touches UnitPrice on this screen
    // (SalesOrderPicking.js's itemJson is a direct passthrough of
    // /sales/get/detail's item.UnitPrice; classifyProducts() never touches
    // UnitPrice, only PriceStatus) — found no live code here that overwrites
    // it. Two real gaps found instead:
    //   1. If /sales/get/detail or /customer/getByCustomerNo failed,
    //      SalesOrderPicking.js never called onOrderLoaded at all — this
    //      screen had no way to even know the load failed. Fixed with a new
    //      onOrderLoadFailed prop on SalesOrderPicking.js (additive/optional
    //      — Invoice.js/InvoicesV2.js don't pass it, so they're unaffected).
    //   2. If /v3/pricing/map failed, loadPricingMap() silently carried on
    //      with an empty map — same visible effect as "nothing configured
    //      for any item", no error. Now tracked via pricingMapLoadFailed.
    // Since the raw value is stored un-coerced (not wrapped in Number()), a
    // missing UnitPrice (null/undefined/empty string) would otherwise render
    // as 0.00 — indistinguishable on screen from "some other value got
    // substituted".
    //
    // What "block before it paints red" means in practice: nothing here
    // prevents SalesOrderPicking.js from writing Products/the DOM inputs —
    // that already happens before onOrderLoaded fires, same as before. What
    // actually keeps the user from ever SEEING a bad row is that
    // LoadingWindow's overlay is full-screen and stays up (its label just
    // changes) from the moment the order starts loading straight through
    // this whole check — the table underneath is hidden the entire time. If
    // validation fails, the retry re-fetches everything before the overlay
    // ever comes down; if it fails twice, clearAll() wipes the Products the
    // user never got to see before the overlay clears.
    //
    // beforeSalesOrderLoad() / afterSalesOrderLoaded() give the loading
    // modal a message per step. Each showState(true, label) call replaces
    // the previous label outright (LoadingWindow keeps a single label in
    // state), so a new message always "hides" the last one — no separate
    // hide step needed.
    // ============================================================

    // Wired to SalesOrderPicking's onBeforeOrderLoad — runs BEFORE it starts
    // fetching. Shown via THIS screen's own modal, then explicitly hidden
    // before returning so it doesn't sit underneath SalesOrderPicking's own
    // (separate) loading overlay, which takes over for the actual fetch.
    beforeSalesOrderLoad = async () => {
        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(true, 'Getting sales order items')
        }
        await this.ensureServerHealthyBeforeLoad('sales_order_list')
        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(false)
        }
    }

    // Wired to SalesOrderPicking's onOrderLoaded — same dedupe + pricing-map
    // classification as afterOrderLoaded(), plus the new integrity check.
    //
    // Credit Memo guard checked HERE, before any modal message — not just
    // inside priceValidation()/validateSalesOrderPriceIntegrity() (which
    // also guard it, defensively). priceValidation() itself returns
    // immediately for CM without touching the modal, so if this method
    // showed "Checking level prices" first and only found out it was a CM
    // afterward, nothing would ever hide that message — the modal would
    // stay stuck open. For CM, skip straight to the same bare call
    // afterOrderLoaded() (the Invoice-list flow) makes, no modal involved,
    // exactly matching pre-2026-08-25 behavior for Credit Memos.
    afterSalesOrderLoaded = async () => {
        // Credit Memo checked FIRST, before touching the modal at all — CM
        // never goes through pricing validation (see priceValidation()'s
        // own guard) and this branch matches its exact pre-2026-08-25
        // behavior: dedupe, classify, done, no modal involved.
        if (this.state.Invoice.InvoiceType === 'CM') {
            const cleanedCM = this.validateNoDuplicateProducts(this.state.Products)
            await new Promise((resolve) => this.setState({ Products: cleanedCM }, resolve))
            await this.priceValidation()
            return
        }

        // 2026-08-27 (client's ask, "mucho cuidado... que no se vea nada") —
        // modal shown as the very FIRST thing, before even the dedupe check
        // below. SalesOrderPicking.js hides its OWN loading overlay right
        // before calling this (its Products/DOM inputs are already
        // populated by then, good or bad), and this method used to not show
        // its own modal until after dedupe + the empty-response check — a
        // real, if brief, gap where NEITHER overlay was up and whatever
        // /sales/get/detail actually returned was sitting on screen
        // uncovered. Closing that gap entirely, not just shrinking it —
        // nothing should ever be visible before it's been validated.
        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(true, 'Getting sales order items')
        }

        const cleaned = this.validateNoDuplicateProducts(this.state.Products)
        await new Promise((resolve) => this.setState({ Products: cleaned }, resolve))

        // /sales/get/detail can come back with status.code: 1 ("successful")
        // but Tabla1/Tabla2 both empty — a real server glitch, not a
        // legitimately item-less Sales Order (there's no such thing as
        // invoicing zero items). SelectOrderDetail() has no way to tell
        // "succeeded with nothing" apart from "succeeded with real data" on
        // its own — it just sets Products to an empty array and moves on.
        // Caught here instead: no visible line at all after a load is
        // treated exactly like any other failed load (same
        // retry-then-support-message path), skipping pricing validation
        // entirely since there's nothing on the invoice to validate yet.
        const hasAnyVisibleLine = this.state.Products.some(p => p.Visible === 1)
        if (!hasAnyVisibleLine) {
            // TEMPORARY DEBUG (2026-08-27) — remove once QA on this
            // validation is done (search "TEMPORARY DEBUG" in this file).
            // console.group('%c[DEBUG] Sales Order load — no visible lines', 'color:#dc2626;font-weight:bold;')
            // console.log('Sales Order:', this.state.Invoice.SalesOrderNo, '| Customer:', this.state.Invoice.Customer.CustomerNo)
            // console.log('Products after load (should be non-empty with at least one Visible === 1):', this.state.Products)
            // console.groupEnd()
            await this.handleSalesOrderValidationFailure(this.state.Invoice.SalesOrderNo, this.state.Invoice.Customer.CustomerNo)
            return
        }

        // 2026-08-27 — more granular step messages (client's ask), one per
        // actual phase instead of a single generic label spanning several
        // seconds of real work: "Getting price levels" covers the
        // /v3/pricing/map fetch inside priceValidation(), "Checking prices"
        // covers the client-side classification that runs right after it
        // resolves (classifyProducts(), already done by the time
        // priceValidation() returns), and "Validating sales order prices"
        // (inside validateSalesOrderPriceIntegrity() below) covers the
        // actual last-lock check. Each showState(true, label) call replaces
        // the previous one outright, so they never overlap on screen.
        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(true, 'Getting price levels')
        }
        await this.priceValidation()
        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(true, 'Checking prices')
        }
        await this.validateSalesOrderPriceIntegrity()
    }

    // Wired to SalesOrderPicking's new onOrderLoadFailed — fires when
    // /sales/get/detail or /customer/getByCustomerNo itself failed, so
    // Products/Invoice were never populated (this.state.Invoice.SalesOrderNo
    // isn't set yet). orderHeader is the same {OrderNo, OrderNameNo, Status}
    // the user originally clicked, passed through so a retry has something
    // to reload.
    afterSalesOrderLoadFailed = async (orderHeader) => {
        if (this.state.Invoice.InvoiceType === 'CM') return
        await this.handleSalesOrderValidationFailure(orderHeader && orderHeader.OrderNo, orderHeader && orderHeader.OrderNameNo)
    }

    // Last-lock check, run after a Sales Order load succeeds and pricing is
    // classified. The "load actually returned something real" half of this
    // lives in afterSalesOrderLoaded() (empty Products) and loadPricingMap()
    // (empty pricing map data) — both route failures here the same way. For
    // every visible line, this method additionally FAILS the load (retry,
    // then "contact Support" — see handleSalesOrderValidationFailure()) on:
    //   - /v3/pricing/map not having succeeded with real data (not just
    //     "loaded with nothing configured" — see pricingMapLoadFailed).
    //   - UnitPrice or unitCost being null/undefined/''/NaN/0 — a 200
    //     response can still carry blanked-out or zeroed fields for a given
    //     line even when the request as a whole "succeeded". This is
    //     genuinely bad/untrustworthy data, not something safe to
    //     auto-correct.
    //   - UnitPrice at or below costAtSale — a hard rule, no exception
    //     (2026-08-27, client's ask: even allowBelowCost never allows a
    //     literal zero-margin sale).
    // UnitPrice below minPrice is NOT a hard failure (2026-08-27, client's
    // ask, changed from an earlier pass that did fail the load on this) —
    // see autoCorrectBelowMinPrices(), called right after this check
    // passes: it silently resets the price to standard and tells the user
    // in one plain info modal, since this case is both expected (an old
    // Sales Order priced before a minimum changed) and fixable, unlike the
    // failures above. maxPrice is NOT enforced at all (2026-08-27, client's
    // ask — a real Sales Order had maxPrice data that was clearly wrong).
    // Both are still shown in the TEMPORARY DEBUG output for reference.
    // This is separate from, and doesn't touch, the existing red/amber
    // PriceStatus system in classifyProducts()/recomputePriceStatus() — that
    // still runs exactly as before; this is an additional gate on top.
    async validateSalesOrderPriceIntegrity() {
        // Same restriction priceValidation() already applies — Credit Memos
        // never go through any of this.
        if (this.state.Invoice.InvoiceType === 'CM') return

        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(true, 'Validating sales order prices')
        }

        const orderNo = this.state.Invoice.SalesOrderNo
        const customerNo = this.state.Invoice.Customer.CustomerNo

        if (this.state.pricingMapLoadFailed) {
            // TEMPORARY DEBUG (2026-08-27) — remove once QA on this
            // validation is done (search "TEMPORARY DEBUG" in this file).
            console.group('%c[DEBUG] Sales Order price validation — pricing map failed', 'color:#dc2626;font-weight:bold;')
            console.log('Sales Order:', orderNo, '| Customer:', customerNo, '| pricingMap entries:', Object.keys(this.state.pricingMap || {}).length)
            console.groupEnd()
            await this.handleSalesOrderValidationFailure(orderNo, customerNo)
            return
        }

        // Returns a human-readable reason string if this line fails
        // integrity, or null if it's fine — same rules as before, just
        // split out so the TEMPORARY DEBUG block below can report exactly
        // which rule tripped for which item instead of just "something's
        // wrong somewhere".
        const evaluateLine = (p) => {
            if (p.Visible !== 1) return null
            if (p.UnitPrice === null || p.UnitPrice === undefined || p.UnitPrice === '') return 'UnitPrice is null/undefined/empty'
            const price = Number(p.UnitPrice)
            // 2026-08-27 (client's ask) — 0 is now also treated as invalid,
            // not just null/undefined/''. A real product never legitimately
            // sells for $0 — this is the same "200 but empty/wrong" server
            // glitch this whole check exists for, just showing up as a
            // zeroed-out field instead of a missing one.
            if (Number.isNaN(price)) return 'UnitPrice is not a number'
            if (price === 0) return 'UnitPrice is 0'

            // Raw sanity check on unitCost — the cost value the line
            // actually carried straight from /sales/get/detail (or the
            // catalog), independent of costAtSale (which only exists once
            // classifyProducts() merges in /v3/pricing/map). A missing or
            // zeroed-out cost here means the SOURCE data itself was bad
            // (e.g. /sales/get/detail came back "successful" with UnitCost
            // blank/0) — same reasoning as the UnitPrice check above.
            if (p.unitCost === null || p.unitCost === undefined || p.unitCost === '') return 'unitCost is null/undefined/empty'
            if (Number(p.unitCost) === 0) return 'unitCost is 0'

            // Cost is an absolute floor regardless of allowBelowCost — a
            // price at or below cost is always invalid, exception or not
            // (2026-08-27, client's ask: even the special-pricing exception
            // never allows a literal zero-margin sale).
            const hasCost = p.costAtSale !== undefined && p.costAtSale !== null
            if (hasCost && price <= Number(p.costAtSale)) return `UnitPrice ($${price}) is at or below costAtSale ($${Number(p.costAtSale)})`

            // minPrice is NOT a hard failure (2026-08-27, client's ask) — a
            // real, expected case (an old Sales Order priced before a
            // minimum went up) doesn't mean the DATA is bad, just that the
            // price is stale. Treating it as a hard failure looped the
            // retry-then-"contact Support" flow every time for a situation
            // that's actually fixable — see autoCorrectBelowMinPrices(),
            // called right after this whole check passes, which resets the
            // price to standard and tells the user in a plain info modal
            // instead of failing the load.
            //
            // maxPrice isn't enforced either (2026-08-27, client's ask) — a
            // real Sales Order surfaced maxPrice data that was clearly
            // wrong/not meant to be enforced this strictly ($15 max on a
            // $105 item). Still shown in the TEMPORARY DEBUG table below
            // for reference, just no longer enforced.
            return null
        }

        const evaluated = this.state.Products.map(p => ({ product: p, reason: evaluateLine(p) }))
        const invalidEntries = evaluated.filter(e => e.reason !== null)
        const invalidItems = invalidEntries.map(e => e.product)

        // TEMPORARY DEBUG (2026-08-27) — logs exactly which item(s) failed
        // and why, so a specific Sales Order's failure can be diagnosed
        // instead of guessing. Remove once QA on this validation is done
        // (search "TEMPORARY DEBUG" in this file).
        if (invalidEntries.length > 0) {
            console.group('%c[DEBUG] Sales Order price validation — invalid line(s) found', 'color:#dc2626;font-weight:bold;')
            console.log('Sales Order:', orderNo, '| Customer:', customerNo, '| Price level:', this.state.customerPriceLevel, '| This is a retry:', this.state.isRetryingSalesOrderPriceCheck)
            console.table(invalidEntries.map(e => ({
                itemCode: e.product.itemCode,
                description: e.product.abbreviatedDesc,
                quantityShipped: e.product.quantityShipped,
                UnitPrice: e.product.UnitPrice,
                unitCost: e.product.unitCost,
                costAtSale: e.product.costAtSale,
                minPrice: e.product.minPrice,
                maxPrice: e.product.maxPrice,
                allowBelowCost: e.product.allowBelowCost,
                exceptionApplies: this.itemAllowsBelowCost(e.product),
                reason: e.reason,
            })))
            console.groupEnd()
        }

        if (invalidItems.length === 0) {
            if (this.state.isRetryingSalesOrderPriceCheck) {
                this.setState({ isRetryingSalesOrderPriceCheck: false })
            }
            await this.autoCorrectBelowMinPrices()
            if (this.ModalLoading.current) this.ModalLoading.current.showState(false)
            return
        }

        await this.handleSalesOrderValidationFailure(orderNo, customerNo)
    }

    // 2026-08-27 (client's ask) — runs only once validateSalesOrderPriceIntegrity()
    // has already confirmed there's no hard failure (bad/missing data,
    // price at or below cost). Silently resets any line still priced below
    // its minPrice — same replacement value checkInvoicePriceFloor() uses
    // for a manually-typed price (standardPriceAtSale, falling back to
    // minPrice itself if that's somehow not cached) — then tells the user
    // ONCE, in a single plain info modal, instead of failing the whole load
    // and looping the retry/"contact Support" flow for something that's
    // both expected (an old Sales Order priced before a minimum changed)
    // and already fixed by the time they see the message. Lines where the
    // allowBelowCost exception applies (itemAllowsBelowCost()) are left
    // alone — minPrice was never their floor to begin with.
    async autoCorrectBelowMinPrices() {
        const corrections = []
        const updatedProducts = this.state.Products.map(p => {
            if (p.Visible !== 1) return p
            if (this.itemAllowsBelowCost(p)) return p
            if (p.minPrice === undefined || p.minPrice === null) return p

            const price = Number(p.UnitPrice)
            const min = Number(p.minPrice)
            if (Number.isNaN(price) || price >= min) return p

            const replacement = (p.standardPriceAtSale !== undefined && p.standardPriceAtSale !== null) ? Number(p.standardPriceAtSale) : min
            const clamped = Number(replacement.toFixed(2))
            corrections.push({ itemCode: p.itemCode, description: p.abbreviatedDesc, from: price, to: clamped })

            const updated = { ...p, UnitPrice: clamped, totalCost: clamped * Number(p.quantityShipped) }
            updated.PriceStatus = this.recomputePriceStatus(updated)
            updated.AffectsInvoiceTotal = this.recomputeAffectsInvoiceTotal(updated)
            return updated
        })

        if (corrections.length === 0) return

        // TEMPORARY DEBUG (2026-08-27) — remove once QA on this is done
        // (search "TEMPORARY DEBUG" in this file).
        console.group('%c[DEBUG] Sales Order — prices auto-corrected to standard', 'color:#2563eb;font-weight:bold;')
        console.table(corrections)
        console.groupEnd()

        await new Promise((resolve) => this.setState({ Products: updatedProducts }, resolve))
        this.refreshInputs()

        // 2026-08-27 fix — this Swal used to fire while the LoadingWindow
        // overlay ("Validating sales order prices") was still up. Both are
        // rendered (LoadingWindow z-index 1040, deliberately below Swal's
        // 1060 — see general-style.css), so the loading spinner/text stayed
        // visible underneath Swal's own semi-transparent backdrop the whole
        // time, and this.ModalLoading.current.showState(false) only ran
        // back in the caller AFTER this whole method (and the Swal it
        // awaits) resolved — reading as "the validating modal never closes
        // on its own". Every other Swal in this same flow already hides the
        // loading modal first (see handleSalesOrderValidationFailure()'s
        // terminal branch); this one just hadn't been brought in line.
        if (this.ModalLoading.current) this.ModalLoading.current.showState(false)

        await Swal.fire({
            icon: 'info',
            title: 'Prices updated',
            text: 'Some prices were below the minimum allowed and were automatically updated to their standard price.',
            confirmButtonText: 'OK'
        })
    }

    // Shared by both failure sources above (the fetch itself failing, and
    // the price-integrity check failing). First time: silently retries by
    // fully reloading the same Sales Order from scratch — no alert, just
    // the "Retrying..." message — which replays the whole step sequence
    // (including "Getting sales order items") from beforeSalesOrderLoad()
    // onward. Second time in a row (isRetryingSalesOrderPriceCheck already
    // true): stops looping, shows a blocking support message, and discards
    // the load entirely via clearAll() — same as clicking "Clear order"
    // (2026-08-25, reverted back from the narrower
    // clearSalesOrderAfterValidationFailure()/keep-the-correlative approach
    // — client's call, favoring a full known-clean reset over the extra
    // surface area of a second partial-clear path).
    async handleSalesOrderValidationFailure(orderNo, customerNo) {
        if (this.state.isRetryingSalesOrderPriceCheck) {
            this.setState({ isRetryingSalesOrderPriceCheck: false })
            if (this.ModalLoading.current) this.ModalLoading.current.showState(false)
            await Swal.fire({
                icon: 'error',
                title: 'Unable to process the information',
                text: 'Please make sure you are connected to the internet and try again. If the problem persists, contact Support.',
                confirmButtonText: 'OK'
            })
            this.clearAll()
            return
        }

        this.setState({ isRetryingSalesOrderPriceCheck: true })
        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(true, 'Retrying — reloading the sales order and validating prices again')
        }

        // Deferred, not awaited inline — SelectOrderDetail() is still on the
        // call stack that led here (this runs from its own onOrderLoaded/
        // onOrderLoadFailed callback) and guards against re-entrancy with
        // its own loadingOrderDetail flag; calling it again synchronously
        // would be a silent no-op. This delay lets that call finish
        // resetting its own state first, and lets the user actually read
        // the message above instead of it flashing by instantly.
        setTimeout(() => {
            if (this.SalesOrderPickingRef.current && orderNo) {
                this.SalesOrderPickingRef.current.SelectOrderDetail({
                    Status: 2,
                    OrderNo: orderNo,
                    OrderNameNo: customerNo
                })
            }
        }, 600)
    }

    // ISSUE 2 fix — sometimes /sales/get/detail (or a manual add race) ends up
    // with two separate rows for the same itemCode, which then both get sent
    // to /invoice/set. Blocks the save and tells the user which item codes
    // are repeated, so they can merge/remove the extra row themselves rather
    // than silently sending duplicated lines (which could double quantities
    // or hide a legitimate BIN/Pallet difference if we merged automatically).
    checkDuplicateProducts() {
        const counts = {};
        this.state.Products.forEach(p => {
            counts[p.itemCode] = (counts[p.itemCode] || 0) + 1;
        });
        const duplicatedCodes = Object.keys(counts).filter(code => counts[code] > 1);
        if (duplicatedCodes.length === 0) return false;

        const rows = duplicatedCodes.map(code => {
            const product = this.state.Products.find(p => p.itemCode === code);
            const desc = product ? ((product.completeDesc && product.completeDesc !== 'null') ? product.completeDesc : product.abbreviatedDesc) : '';
            return `
            <tr>
                <td style="padding: 5px;">${code}</td>
                <td style="padding: 5px;">${desc}</td>
                <td style="padding: 5px;">${counts[code]}</td>
            </tr>`;
        }).join('');

        Swal.fire({
            icon: 'error',
            title: 'Duplicate products found',
            html: `
                <p>The following item codes appear more than once in this invoice. Please remove or merge the duplicate row(s) before saving:</p>
                <table style="width:100%; text-align:left; border-collapse: collapse;">
                <thead>
                    <tr>
                    <th style="border-bottom:1px solid #ccc; padding: 5px;">Item Code</th>
                    <th style="border-bottom:1px solid #ccc; padding: 5px;">Description</th>
                    <th style="border-bottom:1px solid #ccc; padding: 5px;">Times repeated</th>
                    </tr>
                </thead>
                <tbody>
                    ${rows}
                </tbody>
                </table>
            `,
            confirmButtonText: 'OK'
        });

        return true;
    }

    async SaveInvoice(message, mode) {

        if (this.state.Invoice.InvoiceType === 'CM' && this.state.Invoice.InvoiceNo === '') {
            if (message) {
                Swal.fire({
                    title: 'Attention Please!',
                    icon: 'info',
                    text: 'For the Credit Memo you need associate this with a Open Invoice, Please select one and retry'
                })

            }

        } else {
            if (this.checkDuplicateProducts()) {
                return;
            }

            const temporal = this.state.Invoice

            // If it's a Mayaland invoice for Altitude, it will update taxschedule
            const cookieCompany = Number(getValueCookie('CompanyId'));
            // console.log(cookieCompany)
            if (temporal.Customer.CustomerNo === '0016027' && cookieCompany === 3){
                // temporal.Customer.TaxSchedule ='DEFAULT';
                // console.log(temporal)
            }





            if (temporal.SalesOrderNo) {
                let SalesOrderNO = temporal.SalesOrderNo.split('-')
                temporal.SalesOrderNo = SalesOrderNO.length > 1 ? SalesOrderNO[0] : temporal.SalesOrderNo

            }
            // this.compareProductPrices();
            await this.AsignLineSequence()
            await this.refreshInputs()
            const data = {
                Invoice: temporal,
                Products: this.state.Products,
                OrderType: "Invoice",
                idCompany: Number(getValueCookie('CompanyId')),
                username: getValueCookie('userName'),
                company: getValueCookie('Company')
            }
            await saveJsonData('/store/json', data)

            if (this.SecurityPrices()) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Attention please!',
                    text: 'One or more products have a price $0.00,\nif this is correct please type "Accept"',
                    input: 'text',
                    inputPlaceholder: 'Accept',
                    showCancelButton: true,
                    showConfirmButton: true,
                    willOpen: () => {
                        const input = Swal.getInput()
                        const conf = Swal.getConfirmButton()
                        conf.disabled = true
                        input.oninput = () => {
                            if (input.value === 'Accept') {
                                conf.disabled = false
                            } else {
                                conf.disabled = true
                            }


                        }
                    }
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const result = await create_Delete_Update_Information('/invoice/set', data)
                        await getInformationWithDataGlobalSales('/Sales/setStatus', { SalesOrderNo: data.Invoice.SalesOrderNo, OrderStatus: 7 })
                        if (result.status.code === 1) {
                            await this.logInvoiceAuditTrail(data)
                            localStorage.removeItem('InvoiceSave')
                            if (message) {
                                if (this.state.PercentageManual !== 0 || this.state.PercentageScanning !== 0) {
                                    Swal.fire({
                                        title: 'Order Completed!',
                                        html: `
                                        <div className='tableFixHead'>
                                        <table className='table align-middle'>
                                        <thead className='thead'>
                                            <tr className='text-light text-center'>
                                                <th className='bg-dark'>Type</th>
                                                <th className='bg-dark'>Quantity</th>
                                                <th className='bg-dark'>Percentage</th>
                                            </tr>
                                        </thead>
                                        <tbody className='tbody'>
                                            <tr>
                                            <td>Scanned Products</td>
                                            <td>${this.state.TotalScanning}</td>
                                            <td className='text-end'>${pricesFormat(this.state.PercentageScanning)} %</td>
                                            </tr>
                                            <tr>
                                            <td>Manual Products</td>
                                            <td>${this.state.TotalManual}</td>
                                            <td className='text-end'>${pricesFormat(this.state.PercentageManual)}%</td>
                                            </tr>
                                        </tbody>
                                        <tfoot className='tfoot'>
                                        <tr className='bg-secondary text-light'>
                                        <td>Total</td>
                                        <td>${this.state.TotalManual + this.state.TotalScanning}</td>
                                        <td>${100} %</td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                            </div>
                                            `,
                                        icon: 'success',
                                        showCancelButton: false,
                                        confirmButtonText: 'Ok',

                                    }
                                    )

                                } else {
                                    confirmCloseAlert('correct', 'The Invoice was saved successfully!')
                                }

                                this.setState({ enablePrint: false })
                            }

                            //this.clearAll()
                            await this.validateAndOpenPrint(mode, data.Invoice.InvoiceNo, data.Products)
                        }
                    }
                })
            } else {
                const result = await create_Delete_Update_Information('/invoice/set', data)
                await getInformationWithDataGlobalSales('/Sales/setStatus', { SalesOrderNo: data.Invoice.SalesOrderNo, OrderStatus: 7 })
                if (result.status.code === 1) {
                    await this.logInvoiceAuditTrail(data)
                    localStorage.removeItem('InvoiceSave')
                    if (message) {
                        if (this.state.PercentageManual !== 0 || this.state.PercentageScanning !== 0) {
                            Swal.fire({
                                title: 'Order Completed!',
                                html: `
                            <div className='tableFixHead'>
                            <table className='table align-middle'>
                            <thead className='thead'>
                                <tr className='text-light text-center'>
                                    <th className='bg-dark'>Type</th>
                                    <th className='bg-dark'>Quantity</th>
                                    <th className='bg-dark'>Percentage</th>
                                </tr>
                            </thead>
                            <tbody className='tbody'>
                                <tr>
                                <td>Scanned Products</td>
                                <td>${this.state.TotalScanning}</td>
                                <td className='text-end'>${pricesFormat(this.state.PercentageScanning)} %</td>
                                </tr>
                                <tr>
                                <td>Manual Products</td>
                                <td>${this.state.TotalManual}</td>
                                <td className='text-end'>${pricesFormat(this.state.PercentageManual)}%</td>
                                </tr>
                            </tbody>
                            <tfoot className='tfoot'>
                            <tr className='bg-secondary text-light'>
                            <td>Total</td>
                            <td>${this.state.TotalManual + this.state.TotalScanning}</td>
                            <td>${100} %</td>
                            </tr>
                            </tfoot>
                        </table>
                                </div>
                                `,
                                icon: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'Ok',
                            }
                            )
                        } else {
                            confirmCloseAlert('correct', 'The Invoice was saved successfully!')
                        }
                        this.setState({ enablePrint: false })
                    }
                    //this.clearAll()
                    await this.validateAndOpenPrint(mode, data.Invoice.InvoiceNo, data.Products)

                    // Create the invoice for MY automatically

                }
            }
        }
    }

    /**
     * "Never lose an invoice" (2026-09-09, client's ask) — after /invoice/set
     * reports success (result.status.code === 1), that alone doesn't
     * guarantee the invoice actually landed correctly server-side. This
     * double-checks it before showing the PDF: shows a loading message for a
     * fixed 5s (giving the backend a moment to settle), switches the message,
     * then confirms the InvoiceNo actually shows up in /invoice/header AND
     * that /invoice/detail for it matches what was just sent (same line
     * count, itemCode/quantityShipped/UnitPrice per line). On success, opens
     * the PDF exactly as before (OpenPrint(mode)); on failure, tells the user
     * to retry Save and Print, or fall back to Print Only + IT support.
     *
     * Scoped to the Save and Print flow ONLY — mode is "Prices"/"NoPrices"
     * there (see PrintAndSave()/finishSaveInvoice()). The plain "Save
     * Invoice" button (SaveInvoice(true), no mode — see its onClick) calls
     * OpenPrint(mode) here with mode === undefined, which short-circuits
     * straight to the original, completely unchanged call — no 5s wait, no
     * validation, no behavior change for that button at all.
     *
     * IN only (2026-09-10, client's ask) — Credit Memos were tripping this
     * check far more often than regular Invoices, most likely because
     * /invoice/header and /invoice/detail query SO_InvoiceHeader/Detail
     * live in MAS90 (see checkInvoicePersistedCorrectly()'s own comment),
     * and CM lines there may not carry the same sign/shape our comparison
     * assumes — unconfirmed without real mismatch data. Rather than guess
     * at a fix, CM goes back to the exact pre-2026-09-09 behavior (straight
     * to OpenPrint(mode), no wait, no check) until there's a validation
     * approach proven safe for CM specifically. IN keeps the check as-is.
     */
    async validateAndOpenPrint(mode, savedInvoiceNo, savedProducts) {
        if (mode === undefined || !ENABLE_INVOICE_PERSISTENCE_CHECK || this.state.Invoice.InvoiceType === 'CM') {
            await this.OpenPrint(mode)
            return
        }

        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(true, 'Validating the information')
        }
        await new Promise((resolve) => setTimeout(resolve, 5000))
        if (this.ModalLoading.current) {
            this.ModalLoading.current.showState(true, 'Validating invoice was loaded correctly')
        }

        const isValid = await this.checkInvoicePersistedCorrectly(savedInvoiceNo, savedProducts)

        if (this.ModalLoading.current) this.ModalLoading.current.showState(false)

        if (isValid) {
            await this.OpenPrint(mode)
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Attention',
                text: 'This invoice could not process totally. Please click on save and print again. If the problem persist click on print only and send it to TI Support',
                confirmButtonText: 'OK'
            })
        }
    }

    /**
     * The actual header+detail check validateAndOpenPrint() runs. Entirely
     * separate from /invoice/set's own result.status.code check above — this
     * runs strictly AFTER that already reported success, as an extra
     * integrity pass, and never touches Products/Invoice state itself (a
     * read-only check). Any fetch failure or unexpected shape here is
     * treated as "not valid" (fails closed) rather than throwing, since the
     * whole point is to catch a silently-broken persist, not to add a new
     * crash surface to the save flow.
     */
    async checkInvoicePersistedCorrectly(invoiceNo, savedProducts) {
        try {
            const salesPerson = getValueCookie('TypeUser') === '8' ? '0000' : getValueCookie('SalesPerson')
            const headerData = {
                SalespersonNo: salesPerson,
                idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
                CustomerNo: '*'
            }
            const headerResp = await getInformationWithData('/invoice/header', headerData)
            if (!headerResp || !headerResp.status || headerResp.status.code !== 1 || !Array.isArray(headerResp.data)) return false
            if (getIndexElement(headerResp.data, 'InvoiceNo', invoiceNo) === -1) return false

            const detailData = {
                idCompany: Number(getValueCookie('CompanyId')),
                InvoiceNo: invoiceNo,
                CustomerNo: this.state.Invoice.Customer.CustomerNo,
                HeaderSeqNo: '000000',
                company: getValueCookie('Company'),
                idcompany: getValueCookie('CompanyId'),
            }
            const detailResp = await getInformationWithData('/invoice/detail', detailData)
            if (!detailResp || !detailResp.status || detailResp.status.code !== 1 || !Array.isArray(detailResp.data)) return false

            // 2026-09-10 fix — the itemCode/qty/price match below is now
            // whitespace/type tolerant: MAS90-backed fields commonly come
            // back padded (fixed-width CHAR columns) or as numeric strings,
            // so the original strict `===` / `.toFixed() !== .toFixed()`
            // comparison could report a real, correctly-saved line as a
            // mismatch (a false positive) purely from formatting, not an
            // actual data problem — confirmed 2026-09-10, the invoice was
            // fine in both /invoice/header and /invoice/detail but this
            // still reported invalid. Also dropped the overall
            // detailResp.data.length === expected.length requirement — the
            // ask is specifically that every line we sent shows up with the
            // same itemCode/quantityShipped/UnitPrice, not that the backend
            // echoes back exactly as many rows and nothing else (an extra
            // row on the detail response that isn't one of our Products
            // would have failed this for no real reason).
            const expected = savedProducts.filter((p) => p.Visible === 1 && Number(p.quantityShipped) !== 0)
            const normalizeCode = (code) => (code || '').toString().trim().toUpperCase()
            const mismatches = []

            for (const p of expected) {
                const wanted = normalizeCode(p.itemCode)
                const match = detailResp.data.find((d) => normalizeCode(d.ItemCode) === wanted)
                if (!match) {
                    mismatches.push({ itemCode: p.itemCode, reason: 'not found in /invoice/detail' })
                    continue
                }
                if (Math.abs(Number(match.QuantityShipped) - Number(p.quantityShipped)) > 0.001) {
                    mismatches.push({ itemCode: p.itemCode, reason: `quantityShipped ${p.quantityShipped} vs detail ${match.QuantityShipped}` })
                    continue
                }
                if (Math.abs(Number(match.UnitPrice) - Number(p.UnitPrice)) > 0.01) {
                    mismatches.push({ itemCode: p.itemCode, reason: `UnitPrice ${p.UnitPrice} vs detail ${match.UnitPrice}` })
                }
            }

            if (mismatches.length > 0) {
                // TEMPORARY DEBUG (2026-09-10) — remove once QA on this
                // validation is done (search "TEMPORARY DEBUG" in this
                // file). Reports exactly which line(s) tripped the check and
                // why, instead of just "invalid" with no way to tell if
                // it's a real backend problem or a comparison bug here.
                console.group('%c[DEBUG] Invoice persistence check — mismatch(es) found', 'color:#dc2626;font-weight:bold;')
                console.log('InvoiceNo:', invoiceNo)
                console.table(mismatches)
                console.groupEnd()
                return false
            }
            return true
        } catch (error) {
            return false
        }
    }

    /**
     * Writes to document_audit_trail — AFTER /invoice/set already saved the
     * invoice, at both save call sites in SaveInvoice() (the $0-price
     * confirmation branch and the normal one). Mirrors SalesOrderV3.js's own
     * logAuditTrail() (same /v3/audit/log endpoint/shape, same "never
     * blocks the save flow" contract — the invoice itself is already saved
     * by the time this runs, so a failure here only gets logged, never
     * surfaced to the user or retried).
     *
     * InvoiceV3-specific fields (2026-08-27):
     *   - docType: 'credit_memo' for InvoiceType 'CM', 'invoice' otherwise —
     *     Credit Memos go through this same SaveInvoice()/data shape, but
     *     are a distinct document type in the audit trail.
     *   - action: 'edited' when addTitle === 'REPRINT-' — the flag this
     *     screen already uses for "this invoice already existed and was
     *     reloaded" (see BatchNumberModal/ConfirmBatchNumber), the closest
     *     InvoiceV3 equivalent to SalesOrderV3's isNotNewSO. Otherwise
     *     'converted_to_invoice' when a SalesOrderNo is attached (built
     *     from a loaded Sales Order) or 'created' when there isn't one
     *     (built from scratch via catalog/UPC, no Sales Order involved) —
     *     "converted" wouldn't make sense for an invoice that was never
     *     anything else first.
     *   - linkedSoNo: the Sales Order this invoice was converted from, or
     *     null when it wasn't converted from one.
     */
    async logInvoiceAuditTrail(data) {
        try {
            const docType = data.Invoice.InvoiceType === 'CM' ? 'credit_memo' : 'invoice'
            const action = this.state.addTitle === 'REPRINT-'
                ? 'edited'
                : (data.Invoice.SalesOrderNo ? 'converted_to_invoice' : 'created')
            await getInformationWithDataV3('/v3/audit/log', {
                docType,
                docNo: data.Invoice.InvoiceNo,
                idCompany: data.idCompany,
                action,
                salespersonNo: data.Invoice.Customer && data.Invoice.Customer.SalespersonNo,
                linkedSoNo: data.Invoice.SalesOrderNo || null,
            })
        } catch (error) {
            console.error('logInvoiceAuditTrail failed (Invoice itself was already saved):', error)
        }
    }

    // async createMYInvoice(data) {
    //     const orderStatus = 7

    //     // Update the MY prices
    //     let mayalandTemporal = data;
    //     mayalandTemporal.idCompany = "3"
    //     mayalandTemporal.company = 'Mayaland Atlanta'
    //     mayalandTemporal.Customer.CustomerNo = '0016027';
    //     mayalandTemporal.Detail = this.updateAltitudePrices(mayalandTemporal.Detail);
        
    //     // const result = await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)
    //     await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)

    //     // Create SalesOrder

    //     // Create order Status
    //     await getInformationWithDataGlobalSales('/Sales/setStatus', { SalesOrderNo: data.Invoice.SalesOrderNo, OrderStatus: 7 })
    // }

    updateAltitudePrices(productList){
        productList.forEach(element => {
            const altitudePrice = element.LastTotalUnitCost / 0.95;
            element.UnitPrice = Number(altitudePrice.toFixed(2))
        });
        return productList;
    }

    async refreshInputs() {
        includedItems = [];
        const temporal = this.state.Products
        document.getElementById("FreightAmtInvoice").value = this.state.Invoice.FreightAmt
        document.getElementById("CarrierInvoice").value = this.state.Invoice.Comment
        for (let a = 0; a < temporal.length; a++) {
            let unitPriceInput = temporal[a].UnitPrice;
            document.getElementById("unitPriceInvoice_" + a).value = pricesFormat(unitPriceInput)
            document.getElementById("quantityShippedInvoice_" + a).value = temporal[a].quantityShipped
        }
        this.calculateTotals()
    }

    clearAll() {
        const temporal = this.state.Invoice.BatchNo
        localStorage.removeItem('InvoiceSave')
        this.setState({
            Invoice: {
                InvoiceNo: '',
                InvoiceDate: '',
                BatchNo: temporal,
                InvoiceType: 'IN',
                Warehouse: '000',
                SalespersonNo: '',
                Comment: '',
                FreightAmt: 0,
                Customer: {
                    AddressLine1: '',
                    City: '',
                    CountryCode: '',
                    CreditLimit: 0,
                    CustomerName: '',
                    CustomerNo: '',
                    EmailAddress: '',
                    FaxNo: '',
                    PriceLevel: '',
                    SalespersonNo: '',
                    State: '',
                    TaxSchedule: '',
                    TelephoneNo: '',
                    TermsCode: '',
                    UDF_RUTA: '',
                    ZipCode: '',
                },
                TotalQuantityOrdered: 0,
                TotalCost: 0,
                TotalWeight: 0,
                TotalQuantityShipped: 0,
                SalesOrderNo: '',
                ApplyToInvoiceNo: '',
                Duplicate: false
            },
            Products: [],
            Balance: {
                HeaderBalance: [],
                TermsCode: '',
                TotalBalance: 0,
                SelectedInvoice: '',
                Detail: []
            },
            oldInvoice: false,
            temporalBatchNo: '',
            enablePrint: true,
            addTitle: '',
            PercentageScanning: 0,
            PercentageManual: 0,
            TotalManual: 0,
            TotalScanning: 0,
            cmPriceCeilings: {},
        })
    }

    partialClear() {
        const temporal = this.state.Invoice

        this.setState({
            Invoice: {
                InvoiceNo: '',
                InvoiceDate: '',
                BatchNo: temporal.BatchNo,
                Warehouse: temporal.Warehouse,
                InvoiceType: temporal.InvoiceType,
                SalespersonNo: '',
                Comment: '',
                FreightAmt: 0,
                Customer: temporal.Customer,
                TotalQuantityOrdered: 0,
                TotalCost: 0,
                TotalWeight: 0,
                TotalQuantityShipped: 0,
                SalesOrderNo: '',
                ApplyToInvoiceNo: '',
                Duplicate: false
            },
            Products: [],
            oldInvoice: false,
            temporalBatchNo: '',
            enablePrint: true,
            PercentageScanning: 0,
            PercentageManual: 0,
            TotalManual: 0,
            TotalScanning: 0,
            cmPriceCeilings: {},
        })
    }

    realLongDetail() {
        let cont = 0
        this.state.Products.forEach(element => {
            if (element.Visible === 1 && element.quantityShipped > 0) {
                cont++
            }
        });
        return cont
    }

    printDetail(type) {
        let detail = []
        if (type === 'Zebra') {
            this.state.Products.forEach(element => {

                if (element.Visible === 1 && element.quantityShipped !== 0) {
                    element.abbreviatedDesc = (element.completeDesc && element.completeDesc !== "null") ? element.completeDesc : element.abbreviatedDesc
                    element.InvoiceDesc = element.abbreviatedDesc + " @ $ " + pricesFormat(NumberFormat(element.UnitPrice))
                    let upc = 0
                    if (element.caseupc !== "null" && element.caseupc !== "" && element.caseupc !== "undefined" && element.caseupc) {
                        upc = element.caseupc
                    } else if (element.upc !== "null" && element.upc !== "" && element.upc !== "undefined" && element.upc) {
                        upc = element.upc

                    } else if (element.upc2 !== "null" && element.upc2 !== "" && element.upc2 !== "undefined" && element.upc2) {
                        upc = element.upc2
                    }
                    element.upc = upc
                    detail.push(element)
                }
            });
        } else {
            this.state.Products.forEach(element => {

                if (element.Visible === 1 && element.quantityShipped !== 0) {
                    element.abbreviatedDesc = (element.completeDesc && element.completeDesc !== "null") ? element.completeDesc : element.abbreviatedDesc

                    let upc = 0
                    if (element.caseupc !== "null" && element.caseupc !== "" && element.caseupc !== "undefined" && element.caseupc) {
                        upc = element.caseupc
                    } else if (element.upc !== "null" && element.upc !== "" && element.upc !== "undefined" && element.upc) {
                        upc = element.upc

                    } else if (element.upc2 !== "null" && element.upc2 !== "" && element.upc2 !== "undefined" && element.upc2) {
                        upc = element.upc2
                    }
                    element.upc = upc
                    detail.push(element)
                }
            });
            // 2026-08-25 fix — this used to pad `detail` with blank filler
            // rows (first up to the next multiple of a fixed 45/55
            // rows-per-page count, then various fixed buffer sizes) so the
            // last page would look "closed" instead of ending abruptly.
            // Every fixed number tried looked wrong for some invoice size —
            // too little padding leaves an abrupt cutoff, too much leaves a
            // half-or-fully blank trailing page — because this code has no
            // way to know how much room is actually left on the last real
            // page before @react-pdf/renderer lays it out. Removed the
            // padding entirely: the table now ends right after the last
            // real row (with totals immediately below, same as always),
            // which is the only option that never produces a blank page
            // regardless of how many items the invoice has. If a visual
            // "closing" buffer is wanted back, it needs real data on
            // remaining page space to size correctly — see the PDF-library
            // discussion (jsPDF/autoTable exposes that; @react-pdf/renderer
            // doesn't) before picking a fixed number again.
        }




        return detail
    }

    cancelWithBatchNo(modal) {
        this.setState({ temporalBatchNo: '', [modal]: false })
        // this.handleModalClose('showModal1')
    }

    textTermsCode(num) {
        switch (Number(num)) {
            case 0:
                return 'Pay in Advance'
            case 1:
                return 'FOB Taiwan'
            case 7:
                return 'Net 07 Days'
            case 10:
                return 'Net 10 Days'
            case 15:
                return 'Net 15 Days'
            case 21:
                return 'Net 21 Days'
            case 30:
                return 'Net 30 Days'
            case 45:
                return 'Net 45 Days'
            default:
                return ''
        }

    }

    AutoSave() {
        localStorage.setItem('InvoiceSave', JSON.stringify(this.state))
    }
    componentDidMount() {
        window.addEventListener('storage', this.handleStorageChange);
        if (localStorage.getItem('InvoiceSave')) {
            let infoRec = JSON.parse(localStorage.getItem('InvoiceSave'));
            if (infoRec) {
                this.setState({ Products: infoRec.Products, Invoice: infoRec.Invoice })
            }
        }

        // Standardized pricing (2026-08-20) — see componentDidUpdate below,
        // which fires loadPricingMap() whenever Invoice.Customer.CustomerNo
        // changes. Seed the "previous" value now so a customer already
        // restored from localStorage above doesn't get skipped.
        this.__prevInvoiceCustomerNo = this.state.Invoice.Customer.CustomerNo;

        // TODO (MEJORA 1): fire `ensureServerHealthy({ loadingRef: this.ModalLoading })`
        // here, in the background (don't await / don't block the mount), so the
        // shared 5-min cache is already warm by the time the user clicks
        // New Invoice / Sales Order list / Invoice list. Silent unless it needs
        // to escalate — see functions/serverConnectionCheck.js.
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
    }

    /**
     * Standardized pricing (2026-08-20) — mirrors SalesOrderV3.js's own
     * componentDidUpdate: reloads the price map whenever the selected
     * customer changes, covering all 3 InvoiceV3 flows in one hook (manual
     * customer pick on a new invoice, loading a Sales Order, loading an
     * existing Invoice from the list) since all three end up setting
     * Invoice.Customer.CustomerNo.
     */
    componentDidUpdate(prevProps, prevState) {
        const currCustomerNo = this.state.Invoice.Customer.CustomerNo
        if (currCustomerNo !== this.__prevInvoiceCustomerNo) {
            this.__prevInvoiceCustomerNo = currCustomerNo
            this.ensurePricingMapLoaded()
        }
    }

    // MEJORA 1 — generic server-health gate, shared by "New Invoice" (before
    // requesting the correlative InvoiceNo) and "Sales Order list" (before
    // loading a selected order's detail, via SalesOrderPicking's optional
    // onBeforeOrderLoad hook). Reuses the shared 5-min/2-min cache, so this
    // is a no-op most of the time. Non-blocking by design, consistent with
    // the rest of this feature: on definitive failure, ensureServerHealthy()
    // already notifies IT internally — we don't stop the user here, since
    // there's no offline/"Save temporal" flow built yet to fall back to.
    async ensureServerHealthyBeforeLoad(context) {
        await ensureServerHealthy({
            loadingRef: this.ModalLoading,
            notifyContext: { screen: 'InvoiceV3', trigger: context }
        });
    }

    // ─────────────────────────────────────────────────────────────────────
    // Standardized pricing (2026-08-20) — replaces the old MEJORA 2 flow,
    // which fetched /v2/Items/get and compared against cost*1.05/
    // catalogPrice, Altitude-only. Now sources from the same /v3/pricing/map
    // SalesOrderV3.js uses, applies to BOTH companies (Mayaland previously
    // had no price validation at all here), and keeps the red/amber
    // classification + Save/Print blocking — client's ask: still needed as
    // live feedback when a price is changed by hand — with new thresholds:
    //   RED (blocks everyone):      UnitPrice < minPrice (the hard floor — AT
    //                                the floor is allowed, 2026-08-20 fix)
    //   AMBER (blocks non-level-1): minPrice <= UnitPrice < standardPrice
    // No more server-health gate / IT notification / retry / typed
    // confirmation modal for this step — pricingMap is a plain client-side
    // GET (like SalesOrderV3.js's loadPricingMap()), so there's no "catalog
    // might be stale" problem left to guard against. The general
    // ensureServerHealthyBeforeLoad() gate above (MEJORA 1, before loading a
    // SO/Invoice) is untouched — unrelated to pricing.
    //
    // Called from the same two places as before:
    //   - Right after a Sales Order or Invoice is loaded (onOrderLoaded).
    //   - PrintAndSave() at save/print time, as a final safety net for
    //     prices edited by hand after loading.
    // ─────────────────────────────────────────────────────────────────────

    /**
     * Loads the standardized price table for this session's company and the
     * currently selected Invoice customer — itemCode -> {cost,
     * standardPrice, minPrice, maxPrice, level1Price}. Mirrors
     * SalesOrderV3.js's loadPricingMap() exactly (same endpoint/shape).
     * Re-classifies whatever is currently in Products afterward — see
     * classifyProducts(), which never overwrites UnitPrice, only colors it.
     * Awaits classification fully before returning (plain setState
     * callbacks aren't awaitable on their own — classifyProducts() wraps
     * its own setState in a Promise so `await` here means what it says).
     * Discards its own result if the customer changes mid-flight — see
     * isStillCurrent() below. Call ensurePricingMapLoaded() instead of this
     * directly — see its comment for why (single in-flight request per
     * customer, no duplicate/racing fetches).
     */
    async loadPricingMap() {
        // Captured now, before the fetch — if the customer changes while this
        // request is in flight (user loads a second SO/Invoice for a
        // DIFFERENT customer before this one returns), this response no
        // longer belongs to the current screen and must be discarded rather
        // than applied — otherwise it silently classifies the NEW customer's
        // Products against the OLD customer's prices. See
        // ensurePricingMapLoaded() for the other half of this fix (sharing
        // one in-flight request per customer instead of firing duplicates).
        const requestedCustomerNo = (this.state.Invoice.Customer.CustomerNo || '').trim()
        const isStillCurrent = () => (this.state.Invoice.Customer.CustomerNo || '').trim() === requestedCustomerNo

        try {
            const idCompany = getValueCookie('CompanyId')
            const resp = await getInformationWithDataV3('/v3/pricing/map', { idCompany, customerNo: requestedCustomerNo })
            if (!isStillCurrent()) return // a newer request for a different customer now owns this state

            const map = {}
            // 2026-08-25 — tracked separately from `map` being merely empty,
            // so validateSalesOrderPriceIntegrity() can tell "the request
            // itself failed" apart from "it succeeded". 2026-08-27 — also
            // now requires resp.data to be non-empty: a 200/status.code:1
            // response with `data: []` is treated the same as an outright
            // failure (client's ask — a Sales Order that made it past the
            // "has at least one line" check right above this method call
            // should always have SOME pricing configured for its items;
            // coming back with nothing is a server glitch, not a
            // legitimately unconfigured customer).
            let mapFetchSucceeded = false
            if (resp && resp.status && resp.status.code === 1 && Array.isArray(resp.data) && resp.data.length > 0) {
                mapFetchSucceeded = true
                for (const row of resp.data) {
                    // Trimmed defensively (2026-08-20) — same reasoning as the
                    // customerNo trim above: Products loaded from a Sales
                    // Order/Invoice get their itemCode from the legacy
                    // MAS90-backed /sales/get/detail, while this map's
                    // itemCode comes from the RDS-based v3 endpoint. A stray
                    // space on either side would silently fail the lookup in
                    // classifyProducts() below (item falls into the
                    // 'unverified' branch — same fix applied there to the
                    // lookup key).
                    const key = (row.itemCode || '').trim()
                    map[key] = {
                        cost: row.cost !== null && row.cost !== undefined ? Number(row.cost) : null,
                        standardPrice: row.standardPrice !== null && row.standardPrice !== undefined ? Number(row.standardPrice) : null,
                        minPrice: row.minPrice !== null && row.minPrice !== undefined ? Number(row.minPrice) : null,
                        maxPrice: row.maxPrice !== null && row.maxPrice !== undefined ? Number(row.maxPrice) : null,
                        level1Price: row.level1Price !== null && row.level1Price !== undefined ? Number(row.level1Price) : null,
                        allowBelowCost: !!row.allowBelowCost,
                    }
                }
            }
            const customerPriceLevel = resp && resp.priceLevel ? Number(resp.priceLevel) : 1
            await new Promise((resolve) => {
                this.setState({ pricingMap: map, pricingLoaded: true, customerPriceLevel, pricingMapLoadFailed: !mapFetchSucceeded }, resolve)
            })
            if (!isStillCurrent()) return
            await this.classifyProducts()
            // 2026-08-25 fix — classifyProducts() is what actually populates
            // costAtSale (from this response) on every line, and
            // getInvoiceV3PriceMargin() prefers costAtSale over unitCost. Up
            // to this point calculateTotals() (called earlier by
            // refreshInputs() right after the order loads) had already run
            // WITHOUT costAtSale, so the on-screen "Trucking number" was
            // still showing the unitCost-based fallback margin. Recomputing
            // here refreshes the display as soon as the real cost is known,
            // instead of leaving it stale until the user happens to touch a
            // price/quantity field. Doesn't affect what gets printed/saved —
            // printInvoice() already recomputes fresh from this.state.Products.
            this.calculateTotals()
        } catch (error) {
            console.error('loadPricingMap failed:', error)
            if (!isStillCurrent()) return
            // Fail open on pricingLoaded so classifyProducts() actually runs
            // (2026-08-20 fix — it used to just set the flag without calling
            // classifyProducts(), so a failed fetch left every item
            // unclassified — no color, no badge — instead of the intended
            // 'unverified' fallback). It will just find nothing in the map
            // and flag every item 'unverified', the correct visible behavior
            // when the map can't load.
            await new Promise((resolve) => this.setState({ pricingLoaded: true, pricingMapLoadFailed: true }, resolve))
            await this.classifyProducts()
            // See the success-path comment above — same reason.
            this.calculateTotals()
        }
    }

    /**
     * Shared front door for loading pricing — componentDidUpdate,
     * priceValidation() (load AND save contexts) all call this instead of
     * loadPricingMap() directly, so there is only ever ONE /v3/pricing/map
     * request in flight per customer no matter how many callers ask for it
     * at once (2026-08-20 fix — this file used to have up to 4 independent
     * triggers for loadPricingMap() on a single load, each racing to
     * setState/classify with no way to tell a stale response from a fresh
     * one; client-reported symptom was colors/the "Minimum: $" badge
     * flickering or vanishing entirely). If a fetch for the SAME customer is
     * already in flight, callers just await that one instead of starting a
     * second. loadPricingMap() itself still discards a response that's gone
     * stale by the time it lands (customer changed mid-flight) — this only
     * prevents firing DUPLICATE requests for the customer that's still current.
     */
    ensurePricingMapLoaded() {
        const customerNo = (this.state.Invoice.Customer.CustomerNo || '').trim()
        if (this.__pricingMapPromise && this.__pricingMapPromiseCustomerNo === customerNo) {
            return this.__pricingMapPromise
        }
        this.__pricingMapPromiseCustomerNo = customerNo
        this.__pricingMapPromise = this.loadPricingMap().finally(() => {
            this.__pricingMapPromise = null
        })
        return this.__pricingMapPromise
    }

    /**
     * Classifies every current Products line against pricingMap
     * (red/amber/ok/unverified) WITHOUT touching UnitPrice — a loaded Sales
     * Order or Invoice keeps whatever price it actually has; this only
     * decides how to color it and whether it blocks Save/Print. New
     * catalogue lines (buildInvoiceCartLine.js) already arrive priced at
     * standardPrice and pre-classified 'ok', so this mostly matters for
     * lines that came from a loaded SO/Invoice (see recomputePriceStatus()
     * for the actual threshold logic, shared with live edits). Returns a
     * Promise that resolves after the setState actually commits (2026-08-20
     * — needed so loadPricingMap() can rely on `await` meaning what it says).
     */
    classifyProducts() {
        return new Promise((resolve) => {
            // CM price ceiling (2026-09-02, client's ask) — a line added to a
            // Credit Memo from the catalog arrives at the catalog's standard
            // price, which may already sit above the ceiling (the price that
            // item had on the invoice being credited, cmPriceCeilings — see
            // InvoiceListCustomerNo.js) before the user ever touches its
            // price field. Folded into this same map pass (both call sites
            // that add/update a line already call classifyProducts()
            // afterward — CatalogueV3Invoice.js's setQuantity() and
            // SearchUPC.js's scan path) instead of a separate setState, to
            // avoid a second render/state race. For anything that isn't a
            // CM this is a pure no-op — `product` passed straight through
            // unchanged — so the rest of this method (and the
            // !pricingLoaded early-exit right below) behaves exactly as
            // before for every other invoice type.
            const isCM = this.state.Invoice.InvoiceType === 'CM'
            const ceilings = this.state.cmPriceCeilings

            if (!this.state.pricingLoaded) {
                if (!isCM) { resolve(); return }
                const clamped = this.state.Products.map((p) => this.applyCreditMemoPriceCeiling(p, ceilings))
                this.setState({ Products: clamped }, resolve)
                return
            }
            const pricingMap = this.state.pricingMap
            const updated = this.state.Products.map((rawProduct) => {
                const product = isCM ? this.applyCreditMemoPriceCeiling(rawProduct, ceilings) : rawProduct
                // Trimmed to match how the map's keys were built in
                // loadPricingMap() — see that comment for why.
                const key = (product.itemCode || '').trim()
                const pricing = pricingMap[key]
                if (!pricing || (pricing.minPrice === null && pricing.standardPrice === null)) {
                    return { ...product, PriceStatus: 'unverified', AffectsInvoiceTotal: this.recomputeAffectsInvoiceTotal(product) }
                }
                const merged = {
                    ...product,
                    minPrice: pricing.minPrice,
                    maxPrice: pricing.maxPrice,
                    level1Price: pricing.level1Price,
                    allowBelowCost: pricing.allowBelowCost,
                    costAtSale: pricing.cost,
                    standardPriceAtSale: pricing.standardPrice,
                }
                merged.PriceStatus = this.recomputePriceStatus(merged)
                merged.AffectsInvoiceTotal = this.recomputeAffectsInvoiceTotal(merged)
                return merged
            })
            this.setState({ Products: updated }, resolve)
        })
    }

    // CM price ceiling (2026-09-02, client's ask) — clamps `product`'s
    // UnitPrice down to `ceilings[itemCode]` (the price that item had on the
    // invoice being credited) if it's currently priced higher. Never raises
    // a price, and $0 is always allowed — this only stops going UP. Silent
    // (no notification) — used from classifyProducts() right after a line is
    // added/updated from the catalog, where a popup on every add would be
    // noisy; checkCreditMemoPriceCeiling() below is the interactive,
    // notifying counterpart for when the user types a price by hand.
    applyCreditMemoPriceCeiling(product, ceilings) {
        if (!ceilings) return product
        const ceiling = ceilings[(product.itemCode || '').trim()]
        if (ceiling === undefined || ceiling === null) return product
        const price = Number(product.UnitPrice)
        if (Number.isNaN(price) || price <= ceiling) return product
        const clamped = Number(Number(ceiling).toFixed(2))
        return { ...product, UnitPrice: clamped, totalCost: clamped * Number(product.quantityShipped) }
    }

    /**
     * CM price ceiling (2026-09-02, client's ask) — interactive counterpart
     * to applyCreditMemoPriceCeiling(), wired alongside (not instead of)
     * checkInvoicePriceFloor() on the same input's onBlur. Early-returns for
     * anything that isn't a CM, so checkInvoicePriceFloor()'s own IN-side
     * minPrice-floor behavior is completely untouched by this — the two
     * never interact. Unlike that floor (which blocks going below a
     * minimum), this blocks going ABOVE the invoice-being-credited's own
     * UnitPrice for that item (cmPriceCeilings) — going down to $0 is always
     * fine. On a violation: clamps back to the ceiling (same replacement
     * applyCreditMemoPriceCeiling() would compute) and tells the user why,
     * via Swal instead of checkInvoicePriceFloor()'s plain alert() — this is
     * new behavior, not bound to matching that older convention.
     */
    checkCreditMemoPriceCeiling = (e, item) => {
        if (this.state.Invoice.InvoiceType !== 'CM') return
        const ceilings = this.state.cmPriceCeilings
        const ceiling = ceilings && ceilings[(item.itemCode || '').trim()]
        if (ceiling === undefined || ceiling === null) return

        const newPrice = Number(e.target.value)
        if (Number.isNaN(newPrice) || newPrice <= ceiling) return

        const clamped = Number(Number(ceiling).toFixed(2))
        const inputId = e.target.id
        const updatedProducts = this.state.Products.map(p => {
            if (p.itemCode !== item.itemCode) return p
            return { ...p, UnitPrice: clamped, totalCost: clamped * Number(p.quantityShipped) }
        })
        this.setState({ Products: updatedProducts }, () => {
            const el = document.getElementById(inputId)
            if (el) el.value = clamped.toFixed(2)
            this.calculateTotals()
        })
        Swal.fire({
            icon: 'warning',
            title: 'Price exceeds the original invoice',
            text: `The unit price for ${item.itemCode} can't be greater than $${clamped.toFixed(2)} — the price it had on the invoice you're crediting against (${this.state.Invoice.ApplyToInvoiceNo}).`,
            confirmButtonText: 'OK'
        })
    }

    /**
     * Unified entry point — same call sites/signature as the old MEJORA 2
     * priceValidation(mode): no `mode` when called from onOrderLoaded
     * (right after a SO/Invoice loads), `mode` set when called from
     * PrintAndSave (save/print time). Credit Memos are still excluded —
     * same restriction the old flow had, unrelated to the company scope
     * change.
     */
    async priceValidation(mode) {
        const isSaveContext = mode !== undefined;

        if (this.state.Invoice.InvoiceType === 'CM') {
            if (isSaveContext) this.finishSaveInvoice(mode);
            return;
        }

        await this.ensurePricingMapLoaded();

        if (isSaveContext) this.finishSaveInvoice(mode);
    }

    // Extracted from the old inline save/print branching so both the
    // "everything is fine" and "user confirmed" paths share it.
    finishSaveInvoice(mode) {
        if (this.state.addTitle !== 'REPRINT-') {
            this.SaveInvoice(true, mode)
        } else {
            this.OpenPrint(mode)
        }
    }

    PrintAndSave(mode) {
        // priceValidation() itself checks InvoiceType and falls through to
        // finishSaveInvoice() when this feature doesn't apply (Credit Memo).
        this.priceValidation(mode)
    }

    // Standardized pricing (2026-08-20, revised 2026-09-01 — client's ask):
    // Print Only / Save and Print / Save without Prices are disabled ONLY by
    // a RED price issue on the table now:
    //   - RED (strictly below minPrice, the hard floor — exactly AT the
    //     floor is allowed): blocks EVERY user, no exception — including
    //     level-1 (TypeUser === '1') — "never lose money", same rule
    //     SalesOrderV3.js enforces on the input itself. There's no
    //     confirmation path around it from these buttons; the price has to
    //     be fixed by hand.
    //   - AMBER (below standardPrice but still at/above minPrice): no longer
    //     blocks anyone, regardless of TypeUser — purely informational (the
    //     row still shows amber-highlighted for visibility).
    // Lines with quantityShipped === 0 are excluded either way — they don't
    // count toward the invoice total, so their price can't block anything
    // even though it's still shown highlighted for visibility.
    hasBlockingRedPrices() {
        return this.state.Products.some(p => p.PriceStatus === 'cost' && p.AffectsInvoiceTotal);
    }

    hasBlockingAmberPrices() {
        // Amber never blocks saving anymore, for any TypeUser (2026-09-01).
        return false;
    }

    hasBlockingPrices() {
        return this.hasBlockingRedPrices();
    }

    blockingPriceMessage() {
        if (this.hasBlockingRedPrices()) return 'Fix the price(s) marked in red (below the minimum price) before saving.';
        return '';
    }

    // Live reclassification for a single row after the user edits its price
    // or quantity by hand, using minPrice/standardPriceAtSale already cached
    // on it from the last classifyProducts()/buildInvoiceCartLine() run — no
    // network call, so it updates instantly as they type. If that row was
    // never classified yet (e.g. pricingMap hasn't resolved for this item),
    // it's left as-is until the next real run. Reflects the real price vs.
    // minPrice/standardPrice regardless of quantity — the qty===0 exclusion
    // lives in recomputeAffectsInvoiceTotal() instead, so the highlight
    // stays visible even when it can't block anything. Applies to BOTH
    // companies now (the old MEJORA 2 flow was Altitude-only) — Credit
    // Memos are still excluded.
    recomputePriceStatus(product) {
        if (this.state.Invoice.InvoiceType === 'CM') {
            return product.PriceStatus;
        }
        if (product.PriceStatus === 'unverified') {
            return product.PriceStatus; // no pricing map row for this item — nothing to compare against
        }
        if (product.minPrice === undefined && product.standardPriceAtSale === undefined) {
            return product.PriceStatus; // nothing cached yet to compare against
        }

        // Floor: priceFloorFor() (minPrice, or costAtSale when
        // allowBelowCost applies) — no fallback to level1Price (2026-08-20
        // fix — see checkInvoicePriceFloor()'s own comment for why).
        const min = this.priceFloorFor(product)
        const standard = product.standardPriceAtSale
        const invoicePrice = Number(product.UnitPrice);

        // Strictly below the floor (2026-08-20 fix) — a price exactly AT the
        // floor is valid (it's the allowed minimum, not a violation of it)
        // and must not block saving, matching checkInvoicePriceFloor()'s own
        // guard. EXCEPT (2026-08-27, client's ask) when the floor in play is
        // the allowBelowCost exception (costAtSale) rather than the normal
        // minPrice — there, exactly AT the floor leaves zero margin and is a
        // violation too. Same isCostFloor distinction checkInvoicePriceFloor()
        // makes, so both always agree on the same row's color.
        const isCostFloor = this.itemAllowsBelowCost(product) && product.costAtSale !== undefined && product.costAtSale !== null
        if (min !== undefined && min !== null && (isCostFloor ? invoicePrice <= min : invoicePrice < min)) return 'cost'; // red
        if (standard !== undefined && standard !== null && invoicePrice < standard) return 'catalog'; // amber
        return 'ok';
    }

    // Whether this row counts toward the invoice total (and therefore
    // toward blocking Save/Print) — independent from what color it shows.
    recomputeAffectsInvoiceTotal(product) {
        return Number(product.quantityShipped) > 0;
    }

    // ============================================================
    // TEMPORARY DEBUG (2026-08-25) — QA tool for the Trucking Number margin
    // fix. Shows, per shipped line, exactly the same cost/price/margin
    // getInvoiceV3PriceMargin() uses, plus the resulting average and the
    // live trucking number, so real invoices can be spot-checked line by
    // line. DELETE this method and its button in the render (search
    // "TEMPORARY DEBUG") once QA on company 6/3 margins is signed off.
    // ============================================================
    debugTruckingMargins = () => {
        const shipped = this.state.Products.filter(p => Number(p.quantityShipped) > 0)
        let totalMargin = 0
        const rows = shipped.map((p, index) => {
            const hasCostAtSale = p.costAtSale !== undefined && p.costAtSale !== null
            const cost = hasCostAtSale ? p.costAtSale : p.unitCost
            const costSource = hasCostAtSale ? 'costAtSale' : 'unitCost (fallback)'
            let margin = 0
            if (p.UnitPrice && cost) {
                margin = Number((((Number(p.UnitPrice) - Number(cost)) / Number(p.UnitPrice)) * 100).toFixed(0))
            }
            totalMargin += margin
            return `
                <tr>
                    <td style="padding:4px; text-align:left; border-bottom:1px solid #ddd; color:#666;">${index + 1}</td>
                    <td style="padding:4px; text-align:left; border-bottom:1px solid #ddd;">${p.itemCode || ''}</td>
                    <td style="padding:4px; text-align:left; border-bottom:1px solid #ddd;">${(p.abbreviatedDesc || '').toString().substring(0, 28)}</td>
                    <td style="padding:4px; border-bottom:1px solid #ddd;">${p.quantityShipped}</td>
                    <td style="padding:4px; border-bottom:1px solid #ddd;">$${Number(cost || 0).toFixed(2)}</td>
                    <td style="padding:4px; border-bottom:1px solid #ddd;">$${Number(p.UnitPrice || 0).toFixed(2)}</td>
                    <td style="padding:4px; border-bottom:1px solid #ddd; font-weight:bold;">${margin}%</td>
                    <td style="padding:4px; border-bottom:1px solid #ddd; font-size:0.75em; color:#666;">${costSource}</td>
                </tr>`
        }).join('')

        const avg = shipped.length > 0 ? (totalMargin / shipped.length).toFixed(0) : '0'
        const currentTrucking = getInvoiceV3PriceMargin(this.state.Products)

        Swal.fire({
            title: 'DEBUG — Márgenes del Trucking Number',
            width: 800,
            html: `
                <div style="max-height:400px; overflow:auto; text-align:left;">
                <table style="width:100%; font-size:0.85em; border-collapse:collapse;">
                    <thead>
                        <tr style="border-bottom:2px solid #333;">
                            <th style="padding:4px; text-align:left;">#</th>
                            <th style="padding:4px; text-align:left;">Item</th>
                            <th style="padding:4px; text-align:left;">Desc</th>
                            <th style="padding:4px;">Cant. enviada</th>
                            <th style="padding:4px;">Costo</th>
                            <th style="padding:4px;">Precio</th>
                            <th style="padding:4px;">Margen</th>
                            <th style="padding:4px;">Fuente del costo</th>
                        </tr>
                    </thead>
                    <tbody>${rows || '<tr><td colspan="8" style="padding:8px;">Sin líneas con cantidad enviada > 0</td></tr>'}</tbody>
                </table>
                </div>
                <hr/>
                <p style="text-align:left;"><b>Líneas contadas (quantityShipped > 0):</b> ${shipped.length} de ${this.state.Products.length} totales en la factura</p>
                <p style="text-align:left;"><b>Promedio calculado (lo que va en el trucking number):</b> ${avg}%</p>
                <p style="text-align:left;"><b>Trucking number generado ahora mismo:</b> ${currentTrucking}</p>
            `,
            confirmButtonText: 'Cerrar'
        })
    }

    printInvoice() {
        const { Products, Invoice } = this.state;
        const priceMargin = getInvoiceV3PriceMargin(Products);
        this.setState({
            Invoice: {
                ...Invoice, 
                Comment: priceMargin 
            },
        });
        let button = document.getElementById('InvoicePrint')
        button.click()
    }

    async OpenPrint(mode) {
        const { Customer, Comment, InvoiceNo } = this.state.Invoice;
        let bottomMessage = `Comment:  ${Comment}`;
        
        if(Customer.CustomerNo === '0016027'){
            let salesOrderComment = '';
            // Get customer Name
            const data = {
                InvoiceNo
            }
            const getAltCustomer = await getInformationWithData('/v2/invoice/alt-customer', data);
            salesOrderComment = getAltCustomer.data.CustomerName;

            if(!salesOrderComment){
                salesOrderComment = document.getElementById("CarrierInvoice").value;
            }

            bottomMessage = `BOX: ${salesOrderComment}`;
        }
        bottomMessage = bottomMessage + '\nNo Returns after 1 day, No se aceptan devoluciones despues de 1 dia.\nAll returned checks will be subject to a $30 precessing fee. Todo cheque devuelto tendra un cargo de $30.'

        this.setState({AltitudeInvoiceComment: bottomMessage})

        let button
        if (mode === "Prices") {
            if (document.getElementById('InvoicePrint')) {
                button = document.getElementById('InvoicePrint')
                button.click()
            }
        } else {
            if (document.getElementById('InvoiceWPrint')) {
                button = document.getElementById('InvoiceWPrint')
                button.click()
            }
        }
    }

    getAltitudeCustomer = async (SalesOrderNo) => {
        // const data = {
        //     idCompany: getValueCookie('CompanyId'),
        //     SalesOrderNo: SalesOrderNo,
        // }
        // const result = await getInformationWithData('/sales/get/header/by-no', data);

        // return result.data[0].Comment

        return document.getElementById("CarrierInvoice").value
    }

    // Functions called from the components
    updateCustomerAddresses = (addresses) => {
        this.setState({ customerShippingAddresses: addresses});
    }

    updateSelectedShippingAddress = (address = {}) => {        
        this.setState({ selectedShippingAddress: address })
        // If the shipping address is different to the bill address
        // Standardize straits of the object according with mas90
        const shippingAddress = {
            ShipToName: address.shipping_name,
            ShipToAddress1: address.shipping_street,
            ShipToCity: address.shipping_city,
            ShipToState: address.shipping_state,
            ShipToZipCode: address.shipping_zip
        }
        this.setState((prevState) => ({
            Invoice: {
                ...prevState.Invoice,
                ...shippingAddress
            }
        }))
    }

    toggleShippingAddress = (status = true) => {
        this.setState({ disabledShippingAddressStatus: status})
    }

    updateShippingAddressList = (newShippingAddresses) => {
        this.setState({customerShippingAddresses: newShippingAddresses})
    }

    render() {
        // TODO: Clean this.state declaring a variable in the render
        return (
            <div className='invoice-v3-page'>
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />
                <div className='page-header text-center'>
                    <h2>Invoice Order</h2>
                    <p>To start please select an Invoice Order type</p>
                </div>
                {/* TEMPORARY DEBUG (2026-08-25) — QA button for the Trucking
                    Number margin fix. DELETE this block (search "TEMPORARY DEBUG")
                    once QA on company 6/3 margins is signed off. */}
                {/* {getValueCookie('TypeUser') === '1' &&
                    <div className='row pb-2'>
                        <div className='col-sm-12 text-center'>
                            <button type="button" className="btn btn-outline-danger btn-sm" onClick={this.debugTruckingMargins}>
                                🐞 DEBUG: Ver márgenes del Trucking Number (temporal)
                            </button>
                        </div>
                    </div>
                } */}
                <div className='row pb-2'>
                    <div className='col-sm-12'>
                        <div className='row d-flex justify-content-center'>
                            <div className='col-sm-12 col-md-4 InputTextBolder mb-4'>
                                <Select value={this.state.selectOptions1[(getIndexElement(this.state.selectOptions1, 'value', this.state.Invoice.InvoiceType))]} isDisabled={false} className='fs-4 text-start' options={this.state.selectOptions1} onChange={(e) => this.onChangeSelects(e, "Type")} placeholder="Select Type" />
                            </div>
                        </div>
                        <div className='row pb-5'>
                            <div className='col-sm-6 mb-3'>
                                <div className='row'>
                                    {this.state.Invoice.InvoiceType === 'CM' ?
                                        <div className='card section-card'>
                                            <div className='card-body'>
                                                <h3 className='card-title text-center'>Invoice</h3>
                                                <div className='row'>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Invoice No:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.InvoiceNo}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Batch No:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.BatchNo}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Sales Person:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.SalespersonNo}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Order Date:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{DateFormatMAS90(this.state.Invoice.InvoiceDate)}</p>
                                                    </div>
                                                    { getValueCookie('TypeUser') === '1' && (
                                                        <>
                                                            <div className='col-12 col-md-6 field-label'>
                                                                <p>Trucking number:</p>
                                                            </div>
                                                            <div className='col-12 col-md-6 field-value'>
                                                                <p>{this.state.TruckingNumber}</p>
                                                            </div>
                                                        </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className='card section-card'>
                                            <div className='card-body'>
                                                <h3 className='card-title text-center'>Invoice</h3>
                                                {/* TODO (MEJORA 1): offline-mode banner goes here — visible while the
                                                    shared server cache (functions/serverConnectionCheck.js) is in a
                                                    known-failed state. Also add the "pending sync" button (badge with
                                                    count, simple list + status, no actions yet) somewhere in this
                                                    toolbar. */}
                                                <div className='col-sm-12 d-grid gap-2 my-3'>
                                                    {/* TODO (MEJORA 1): while in offline mode, swap this for a
                                                        "Save temporal" button that posts to the AWS pending-sync
                                                        endpoint instead of running the normal New Invoice flow. */}
                                                    <button hidden={this.state.Invoice.InvoiceType === 'CM'} type="button" className="btn blueButton btn-lg" onClick={() => this.BatchNumberModal('New')}><FiCheckCircle /> New Invoice</button>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-12 col-md-6 mb-3'>
                                                        <InvoiceListSalesPerson ref={this.InvoiceListSalesPersonRef} disabled={false} headerName='' nombrePadre="InvoiceListSalesPerson" Padre={this} disableShippingAddress={this.toggleShippingAddress} onBeforeOrderLoad={() => this.ensureServerHealthyBeforeLoad('invoice_list')} onOrderLoaded={this.afterOrderLoaded} />
                                                    </div>
                                                    <div className='col-sm-12 col-md-6 mb-3'>
                                                        <InvoiceListSalesPerson disabled={false} headerName='' nombrePadre="InvoiceListSalesPersonHistory" Padre={this} disableShippingAddress={this.toggleShippingAddress}/>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Invoice No:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.InvoiceNo}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Batch No:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.BatchNo}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Sales Person:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.SalespersonNo}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Order Date:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{DateFormatMAS90(this.state.Invoice.InvoiceDate)}</p>
                                                    </div>
                                                    { getValueCookie('TypeUser') === '1' && (
                                                            <div className='col-12 col-md-6 field-label'>
                                                                <p>Trucking number:</p>
                                                            </div>
                                                        )
                                                    }
                                                    { getValueCookie('TypeUser') === '1' && (
                                                            <div className='col-12 col-md-6 field-value'>
                                                                <p>{this.state.TruckingNumber}</p>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='col-sm-6'>
                                <div className='card section-card'>
                                    <div className='card-body'>
                                        <h3 className='card-title text-center'>Sales Order</h3>
                                        <div className='row'>
                                            <div className="pt-3 col-sm-12 d-grid gap-2">
                                                <SalesOrderPicking ref={this.SalesOrderPickingRef} hidden={this.state.Invoice.BatchNo ? false : this.state.Invoice.InvoiceType === 'CM'} disabled={this.state.Invoice.InvoiceNo === ''} headerName='' nombrePadre="SalesOrderListInvoice" Padre={this} onAddressesLoaded={this.updateCustomerAddresses} clearSelectedShippingAddress={this.updateSelectedShippingAddress} disableShippingAddress={this.toggleShippingAddress} onBeforeOrderLoad={this.beforeSalesOrderLoad} onOrderLoaded={this.afterSalesOrderLoaded} onOrderLoadFailed={this.afterSalesOrderLoadFailed} pullSalesPersonFromOrder={true}/>
                                            </div>
                                            <div hidden={this.state.Invoice.InvoiceType === 'CM'} className='col-12 col-md-6 field-label'>
                                                <p>Sales Order:</p>
                                            </div>
                                            <div hidden={this.state.Invoice.InvoiceType === 'CM'} className='col-12 col-md-6 field-value'>
                                                <p>{this.state.Invoice.SalesOrderNo}</p>
                                            </div>
                                            <div hidden={this.state.Invoice.InvoiceType === 'IN'} className='col-12 col-md-6 field-label'>
                                                <p>Apply to Invoice No:</p>
                                            </div>
                                            <div hidden={this.state.Invoice.InvoiceType === 'IN'} className='col-12 col-md-6 field-value'>
                                                <p>{this.state.Invoice.ApplyToInvoiceNo}</p>
                                            </div>
                                            <div className='col-sm-12 d-grid gap-2'>
                                                <InvoiceListCustomerNo hidden={this.state.Invoice.InvoiceType === 'IN'} disabled={this.state.Invoice.Customer.CustomerNo === ''} CustomerNo={this.state.Invoice.Customer.CustomerNo} headerName='' buttonTitle="Select Invoice to Apply" nombrePadre="InvoiceListCustomer" Padre={this} loadPriceCeilings={true} />
                                            </div>
                                            <div className='col-sm-12 row'>
                                                <div className='col-sm-12 col-md-6'>
                                                    <div className='col-sm-12 pt-3 InputTextBolder'>
                                                        <p>Freight:</p>
                                                    </div>
                                                    <div className="col-sm-12 pt-1 input-group input-group-lg flex-nowrap">
                                                        <span className="input-group-text">$</span>
                                                        <input disabled={this.state.Invoice.InvoiceNo === ''} className="form-control form-control-lg text-center" id='FreightAmtInvoice' type="number" min={0.00} defaultValue={this.state.Invoice.FreightAmt} step={0.01} onChange={(e) => this.onTarget(e, '')} onWheel={(e) => e.target.blur()} />
                                                    </div>
                                                    <div className='col-sm-12 pt-3 InputTextBolder'>
                                                        <p>Carrier:</p>
                                                    </div>
                                                    <div className="col-sm-12 input-group input-group-lg">
                                                        <input disabled={this.state.Invoice.InvoiceNo === ''} type="text" autoComplete='off' id='CarrierInvoice' className="form-control" onChange={(e) => this.onTarget(e, '')} placeholder='Carrier...' />
                                                    </div>
                                                </div>
                                                { ['RR','AM'].includes(getValueCookie('SalesPerson')) && (
                                                <div hidden={this.state.Invoice.InvoiceType !== 'IN' || this.state.Invoice.Customer.CustomerNo === ''} className='col-sm-12 col-md-6'>
                                                    <div className='col-sm-12 py-3 InputTextBolder'>
                                                        <p>Shipping Address:</p>
                                                        <small>Leave as "Default" to use the customer's address</small>
                                                    </div>
                                                    <div className="col-sm-12 input-group input-group-lg">
                                                        <ShippingAddress customerNo={this.state.Invoice.Customer.CustomerNo} addresses={this.state.customerShippingAddresses} selectedAddress={this.state.selectedShippingAddress} updateSelectedShippingAddress={this.updateSelectedShippingAddress} updateShippingAddressList={this.updateShippingAddressList} />
                                                    </div>
                                                </div>
                                                )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.isAlreadyInvoiced?
                            <div className="alert alert-warning" role="alert">
                                <h4 className="alert-heading">Notice: This order has already been invoiced</h4>
                                <p>This sales order was previously invoiced. Please double-check to ensure you've selected the correct sales order.</p>
                                <hr />
                                <p className="mb-0">If you have any questions, feel free to contact IT support.</p>
                            </div>
                            :<div></div>
                        }
                        <div className='row d-flex justify-content-center'>
                            {
                                this.state.Invoice.InvoiceType === 'CM' ?
                                    <div className="col-sm-10 text-center">
                                        <div className="alert alert-primary" role="alert">
                                            <h4 className="alert-heading">Before to start:</h4>
                                            <p>Please select a Customer clicking on the Customer List button</p>
                                        </div>
                                    </div>
                                :
                                    <></>
                            }
                            <div className="col-sm-6 input-group-lg mb-3">
                                <input type="text" autoComplete='off' id='search1CustomerListIN' className="form-control" placeholder='Search Customer...' />
                            </div>
                            <div className='col-sm-6 mb-3'>
                            {
                                this.state.Invoice.InvoiceType === 'CM' ?
                                    <CustomerList hidden={this.state.Invoice.BatchNo ? false : true} disabled={(this.state.Invoice.InvoiceNo === '' && this.state.Invoice.InvoiceType === 'IN') || this.state.addTitle !== ''} headerName='Customer' nombrePadre="Invoice" ident="InvoiceCustomerList1" Padre={this} />
                                :
                                    // Locks once a catalogue item has been added (2026-08-20) —
                                    // was locking as soon as ANY customer was picked, even with an
                                    // empty cart, so picking the wrong customer meant no way back
                                    // except the button below. Products still priced/classified for
                                    // the old customer would go stale if swapped mid-cart, so the
                                    // lock still has to kick in once there's something in the cart.
                                    <CustomerList disabled={(this.state.Invoice.InvoiceNo === '' && this.state.Invoice.InvoiceType === 'IN') || this.state.Products.length > 0} headerName='Customer' nombrePadre="Invoice" ident="InvoiceCustomerList1" Padre={this} />
                            }
                            </div>
                            {/* Clear order (2026-08-20) — lets the user start over once the
                                customer picker above has locked (a catalogue item was added),
                                same "Clear order" pattern SalesOrderV3.js already has. */}
                            {/* {this.state.Invoice.InvoiceType !== 'CM' && this.state.Invoice.Customer.CustomerNo && this.state.Products.length > 0 && (
                                <div className='col-sm-12 mb-3 d-flex justify-content-center'>
                                    <button type="button" onClick={() => this.clearAll()} className="btn purpleButtonv2 btn-lg"><FiTrash /> Clear order</button>
                                </div>
                            )} */}
                            <div className='card section-card'>
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-12 col-md-6'>
                                                <div className='row'>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Customer No:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.Customer.CustomerNo}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Name:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.Customer.CustomerName}</p>
                                                    </div>
                                                    {this.state.Invoice.Customer.CustomerNo && (
                                                        <>
                                                            <div className='col-12 col-md-6 field-label'>
                                                                <p>Price Level:</p>
                                                            </div>
                                                            <div className='col-12 col-md-6 field-value'>
                                                                <span style={{
                                                                    background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE',
                                                                    borderRadius: '999px', padding: '2px 10px', fontSize: '0.78rem', fontWeight: 700,
                                                                }}>Level {this.state.customerPriceLevel}</span>
                                                            </div>
                                                        </>
                                                    )}
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Zip Code:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.Customer.ZipCode}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-sm-12 col-md-6'>
                                                <div className='row'>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>State:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.Customer.State}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>City:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.Customer.City}</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-label'>
                                                        <p>Telephone No:</p>
                                                    </div>
                                                    <div className='col-12 col-md-6 field-value'>
                                                        <p>{this.state.Invoice.Customer.TelephoneNo}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div hidden={Number(getValueCookie('SubCompanyId')) !== 5} className='row pt-3'>
                            <div className='col-sm-12 InputTextBolder'>
                                <p>Warehouse:</p>
                            </div>
                            <div className=' pt-2 col-sm-12'>
                                <Select value={this.state.selectOptions2[(getIndexElement(this.state.selectOptions2, 'value', this.state.Invoice.Warehouse))]} isDisabled={false} className='fs-4 text-start' options={this.state.selectOptions2} onChange={(e) => this.onChangeSelects(e, "Warehouse")} placeholder="Select Warehouse" />
                            </div>
                        </div>
                        <div className='row pt-5 d-flex justify-content-center mb-3'>
                            <div className="col-sm-12 col-md-6 input-group-lg">
                                <SearchUPC disabled={this.state.Invoice.Customer.CustomerNo === '' || this.state.addTitle !== ''} ComponentName={'Invoice'} Padre={this} priceLevel={this.state.Invoice.Customer.PriceLevel} />
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <CatalogueV3Invoice Padre={this} colorButton='purpleButton' titleButton='Open Catalogue' disabled={this.state.Invoice.Customer.CustomerNo === '' || this.state.addTitle !== ''} />
                            </div>
                        </div>
                    </div>
                    {/* Standardized pricing (2026-08-20) — price legend, only shown once at least one row is flagged */}
                    {
                        this.state.Products.some(p => p.PriceStatus && p.PriceStatus !== 'ok') &&
                        <div className="d-flex flex-wrap justify-content-center gap-3 align-items-center mb-2 px-2 py-2 rounded" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
                            <span className="fw-bold text-secondary">Price legend:</span>
                            <span className="d-flex align-items-center">
                                <span className="price-legend-swatch row-price-below-catalog"></span>
                                <FiAlertTriangle className="me-1 text-warning" /> Below standard price
                            </span>
                            <span className="d-flex align-items-center">
                                <span className="price-legend-swatch row-price-below-cost"></span>
                                <FiXCircle className="me-1 text-danger" /> At or below min price
                            </span>
                            <span className="d-flex align-items-center">
                                <span className="price-legend-swatch row-price-unverified"></span>
                                <FiHelpCircle className="me-1 text-secondary" /> No standard price configured
                            </span>
                        </div>
                    }
                    <div className='col-sm-12 tableFixHead'>
                        <table className='table align-middle table-hover'>
                            <thead className='table-dark thead'>
                                <tr>
                                    <th className='text-center'>Item Code</th>
                                    <th className='text-center'>Description</th>
                                    <th className='text-center'>Quantity Ordered</th>
                                    <th className='text-center'>Quantity Shipped</th>
                                    <th className='text-center'>Total Weight (lbs)</th>
                                    <th className='text-center'>Unit Price</th>
                                    <th className='text-center'></th>
                                    <th className='text-center'>Total Order</th>
                                    <th className='text-center'></th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.Products.map((item, i) => {
                                        // MEJORA 2 — row highlight priority: below-cost (red) >
                                        // below-catalog (amber) > not-in-catalog (gray) > the
                                        // pre-existing $0.00 price warning.
                                        let priceStatusClass = ''
                                        if (item.PriceStatus === 'cost') priceStatusClass = 'row-price-below-cost'
                                        else if (item.PriceStatus === 'catalog') priceStatusClass = 'row-price-below-catalog'
                                        else if (item.PriceStatus === 'unverified') priceStatusClass = 'row-price-unverified'
                                        else if (item.UnitPrice <= 0) priceStatusClass = 'bg-warning'

                                        return (
                                        <tr className={priceStatusClass + ' ' + (item.Duplicate ? item.Duplicate : '')} key={i} hidden={item.Visible === 0}>
                                            <td className='text-center'>{item.itemCode}</td>
                                            <td className='text-start'>{(item.completeDesc && item.completeDesc !== "null") ? item.completeDesc : item.abbreviatedDesc}</td>
                                            <td className='text-center textTableSize'>
                                                {item.quantityOrdered}
                                            </td>
                                            <td>
                                                <div className="input-group  input-group-lg">
                                                    <input disabled={this.state.addTitle !== ''} type="number" id={'quantityShippedInvoice_' + i} min={0} defaultValue={item.quantityShipped} onChange={(e) => this.onTarget(e, item)} className="form-control text-center inputResize" onWheel={(e) => e.target.blur()} />
                                                </div>
                                            </td>
                                            <td className='text-center textTableSize text-secondary'>
                                                {NumberFormat(Number(item.totalWeight).toFixed(2)) + ' lbs'}
                                            </td>
                                            <td >
                                                <div className="input-group input-group-lg flex-nowrap">
                                                    <span className="input-group-text">$</span>
                                                    <input disabled={this.state.addTitle !== '' || (blockedItems.has(item.itemCode) && this.state.Invoice.InvoiceType === 'IN' )}  type="number" id={'unitPriceInvoice_' + i} min={0} step={0.01} pattern={/([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]/} defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTarget(e, item)} onBlur={(e) => { this.checkInvoicePriceFloor(e, item); this.checkCreditMemoPriceCeiling(e, item); }} className="form-control text-end text-success inputResize" onWheel={(e) => e.target.blur()} />
                                                </div>
                                                {/* Standardized pricing (2026-08-20) — the enforced floor, or a
                                                    warning if this item has no row in product_pricing yet. Matches
                                                    checkInvoicePriceFloor()'s own logic exactly. */}
                                                {item.PriceStatus === 'unverified' ? (
                                                    <div style={{ fontSize: '0.7rem', color: '#991B1B', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                        <FiAlertTriangle /> No standard price configured
                                                    </div>
                                                ) : (() => {
                                                    const floor = this.priceFloorFor(item)
                                                    return (floor !== undefined && floor !== null) ? (
                                                        <div style={{ fontSize: '0.7rem', color: '#64748B', marginTop: '4px' }}>
                                                            {/* Shows the actual floor. 2026-08-27 fix (first pass) — this
                                                                used to always show item.level1Price even under the
                                                                "special pricing" label, which isn't what's actually being
                                                                enforced. 2026-08-27 fix (second pass) — the "Level Price"
                                                                shown for the normal case is standardPriceAtSale
                                                                (standardPrice from /v3/pricing/map), not level1Price —
                                                                level1Price is no longer read anywhere else in this file. */}
                                                            {this.itemAllowsBelowCost(item) ? 'Minimum (special pricing): $' : 'Level Price: $'}{NumberFormat(pricesFormat(this.itemAllowsBelowCost(item) ? floor : item.standardPriceAtSale))}
                                                        </div>
                                                    ) : null
                                                })()}
                                            </td>
                                            <td className='text-end textTableSize text-success'>$</td>
                                            <td className='text-end textTableSize text-success'>
                                                {NumberFormat(Number(item.totalCost).toFixed(2))}
                                            </td>
                                            <td>
                                                <div className="d-grid gap-2">
                                                    <button disabled={this.state.addTitle !== ''} type="button" onClick={() => this.removeProduct(item)} className="btn redButton btn-lg"><FiTrash /></button>
                                                </div>
                                            </td>
                                        </tr>
                                        )
                                    })
                                }
                            </tbody>
                            <tfoot className='tfoot'>
                                <tr className='bg-dark text-white'>
                                    <td></td>
                                    <td className='text-center textTableSize'>Totals</td>
                                    <td className='text-center textTableSize'>{this.state.Invoice.TotalQuantityOrdered}</td>
                                    <td className='text-center textTableSize'>{this.state.Invoice.TotalQuantityShipped}</td>
                                    <td className='text-center textTableSize'>{NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)) + ' lbs'}</td>
                                    <td className='text-end textTableSize'></td>
                                    <td className='text-end textTableSize'>$</td>
                                    <td className='text-end textTableSize'>{NumberFormat(pricesFormat(this.state.Invoice.TotalCost))}</td>
                                    <td></td>

                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    {/* Bottom Action Bar */}
                    <div className='col-sm-12'>
                        <div className='row d-flex justify-content-center'>
                            {/*
                            <div className='col-6 d-grid gap-2'>
                                <button hidden={this.state.Invoice.BatchNo ? false : true} type="button" className="btn greenButton btn-lg" onClick={() => this.SaveInvoice(true)}>Save Invoice <AiOutlineFileAdd /></button>
                            </div>*/}
                            <div className='col-sm-12 col-md-5 d-grid gap-2'>
                                <button disabled={this.state.Products.length === 0 || this.hasBlockingPrices()} title={this.blockingPriceMessage()} type="button" className="btn btn-outline-dark btn-lg" onClick={() => this.printInvoice()}><AiFillPrinter />Print Only</button>
                            </div>
                            <div className='col-sm-12 col-md-5 d-grid gap-2'>
                                <button hidden={this.state.Invoice.BatchNo ? false : (this.state.addTitle !== '' ? false : true)} disabled={this.state.Products.length === 0 || this.hasBlockingPrices()} title={this.blockingPriceMessage()} type="button" className="btn greenButton btn-lg" onClick={() => this.PrintAndSave("Prices")}><AiFillPrinter /> {this.state.addTitle !== 'REPRINT-' ? "Invoice Save and Print" : "Invoice Print"}</button>
                                {this.hasBlockingPrices() && <p className="text-danger text-center mt-1 mb-0"><small>{this.blockingPriceMessage()}</small></p>}
                                <InvoiceZebra
                                    id={'InvoicePrintZebra'}
                                    hidden={true}
                                    colorButton='blackButton'
                                    titleButton='Invoice Print'
                                    title='Invoice Print'
                                    companyLogo={getValueCookie('DocumentsLogo')}
                                    InvoiceType={this.state.addTitle + (this.state.Invoice.InvoiceType === 'IN' ? 'Invoice' : 'Credit Memo')}
                                    CompanyContactInfo={['Altitude LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', '(770) 871-5807']}
                                    InvoiceHeader={[
                                        ['Invoice Number:', this.state.Invoice.InvoiceNo], 
                                        ['Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate)], 
                                        ['Grocer:', this.state.Invoice.SalespersonNo], 
                                        ['Client No:', this.state.Invoice.Customer.CustomerNo], 
                                        ['Client Name:', this.state.Invoice.Customer.CustomerName], ['Address:', this.state.Invoice.Customer.AddressLine1 + ' ' + this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]]}
                                    DescriptionKeys={["quantityShipped", "InvoiceDesc", "$", "totalCost"]}
                                    HeaderDescritpion={["Qty", "Description", "", "AmDescriptionount"]}
                                    StyleDetail={["QuantityColumn", "LongColumn", "SignColumn", "PriceColumn"]}
                                    Detail={this.printDetail("Zebra")}
                                    quantSignDolar={this.realLongDetail()}
                                    keysDecimalFormat={["totalCost"]}
                                    bottomInformation={[
                                        ["", "Net Invoice: ", "$", NumberFormat(pricesFormat(this.state.Invoice.TotalCost))]
                                        , ["", "Freight: ", "$", NumberFormat(pricesFormat(this.state.Invoice.FreightAmt))]
                                        , [NumberFormat(this.state.Invoice.TotalQuantityShipped), "TOTAL", "$", NumberFormat(pricesFormat(Number(this.state.Invoice.FreightAmt) + Number(this.state.Invoice.TotalCost)))]]}
                                    bottomMessage={"NOTE: Returned checks will incur an additional charge of $50.00.\nLos cheques rechazados tendran un cargo adicional de $50.00.\nNo Returns after 24 hours after delivered.\nNo se aceptan devoluciones despues de 24 horas de entregado."}
                                    disabled={this.state.Products.length === 0}
                                />
                                {getValueCookie('CompanyId') !== '6' ?
                                    (MobileDisp() ?
                                        <InvoicePDFInvoiceV3
                                            id={'InvoicePrint'}
                                            hidden={true}
                                            colorButton='orangeButton'
                                            titleButton='Invoice Print'
                                            title='Invoice Print'
                                            CompanyTitle='Mayaland'
                                            InvoiceType={this.state.addTitle + (this.state.Invoice.InvoiceType === 'IN' ? 'Invoice' : 'Credit Memo')}
                                            CompanyContactInfo={['Mayaland LLC', '7055 Amwiler Industrial Dr', 'Suite B\n Atlanta, GA 30360', '(678) 213-1226']}
                                            InvoiceHeader={['Invoice Number:', this.state.Invoice.InvoiceNo, 'Invoice Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate), 'Sales Person:', this.state.Invoice.SalespersonNo, 'Customer Number:', this.state.Invoice.Customer.CustomerNo, 'Batch No:', this.state.Invoice.BatchNo]}
                                            Box1={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                            Box2={[
                                                this.state.Invoice.Customer.CustomerName, 
                                                this.state.Invoice.Customer.AddressLine1,
                                                this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode
                                            ]}
                                            HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(this.state.Invoice.Customer.TermsCode)]}
                                            DescriptionKeys={["quantityShipped", "itemCode", "upc", "abbreviatedDesc", "$", "UnitPrice", "$", "totalCost"]}
                                            HeaderDescritpion={["Qty", "Code", "SKU", "Description", "", "Price", "", "Amount"]}
                                            StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormalCenter", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                            Detail={this.printDetail()}
                                            breakpoint={60}
                                            quantSignDolar={this.realLongDetail()}
                                            keysDecimalFormat={["UnitPrice", "totalCost"]}
                                            bottomInformation={[
                                                NumberFormat(this.state.Invoice.TotalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)), "Net Invoice: ", "$", NumberFormat(pricesFormat(this.state.Invoice.TotalCost)),
                                                "", "", "", "", "", "", "", "", "Freight: ", "$", NumberFormat(pricesFormat(this.state.Invoice.FreightAmt)),
                                                "", "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.Invoice.FreightAmt) + Number(this.state.Invoice.TotalCost)))
                                            ]}
                                            bottomStyle={[
                                                "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "LineButtom2Left", "DolarButtomLeft", "LineButtom2",
                                                "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom2Left", "DolarButtomLeft", "LineButtom2",
                                                "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom3Left", "DolarButtomLeft2", "LineButtom3",
                                            ]}
                                            bottomMessage={this.state.AltitudeInvoiceComment}
                                            disabled={this.state.Products.length === 0}
                                        />
                                        :
                                        <DownloadInvoicePDFInvoiceV3
                                            id={'InvoicePrint'}
                                            hidden={true}
                                            colorButton='orangeButton'
                                            titleButton='Invoice Print'
                                            title='Invoice Print'
                                            CompanyTitle='Mayaland'
                                            InvoiceType={this.state.addTitle + (this.state.Invoice.InvoiceType === 'IN' ? 'Invoice' : 'Credit Memo')}
                                            CompanyContactInfo={['Mayaland LLC', '7055 Amwiler Industrial Dr', 'Suite B\n Atlanta, GA 30360', '(678) 213-1226']}
                                            InvoiceHeader={['Invoice Number:', this.state.Invoice.InvoiceNo, 'Invoice Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate), 'Sales Person:', this.state.Invoice.SalespersonNo, 'Customer Number:', this.state.Invoice.Customer.CustomerNo, 'Batch No:', this.state.Invoice.BatchNo]}
                                            Box1={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                            Box2={[
                                                this.state.Invoice.Customer.CustomerName, 
                                                this.state.Invoice.Customer.AddressLine1,
                                                this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode
                                            ]}
                                            HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(this.state.Invoice.Customer.TermsCode)]}
                                            DescriptionKeys={["quantityShipped", "itemCode", "SKU", "abbreviatedDesc", "$", "UnitPrice", "$", "totalCost"]}
                                            HeaderDescritpion={["Qty", "Code", "SKU", "Description", "", "Price", "", "Amount"]}
                                            StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormalCenter", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                            Detail={this.printDetail()}
                                            breakpoint={60}
                                            quantSignDolar={this.realLongDetail()}
                                            keysDecimalFormat={["UnitPrice", "totalCost"]}
                                            bottomInformation={[
                                                NumberFormat(this.state.Invoice.TotalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)), "Net Invoice: ", "$", NumberFormat(pricesFormat(this.state.Invoice.TotalCost)),
                                                "", "", "", "", "", "", "", "", "Freight: ", "$", NumberFormat(pricesFormat(this.state.Invoice.FreightAmt)),
                                                "", "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.Invoice.FreightAmt) + Number(this.state.Invoice.TotalCost)))
                                            ]}
                                            bottomStyle={[
                                                "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "LineButtom2Left", "DolarButtomLeft", "LineButtom2",
                                                "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom2Left", "DolarButtomLeft", "LineButtom2",
                                                "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom3Left", "DolarButtomLeft2", "LineButtom3",
                                            ]}
                                            bottomMessage={this.state.AltitudeInvoiceComment}
                                            docname={this.state.Invoice.InvoiceNo}
                                            disabled={this.state.Products.length === 0}
                                        />
                                    )
                                    :
                                    (
                                        MobileDisp() ?
                                            <InvoicePDF2InvoiceV3
                                                id={'InvoicePrint'}
                                                hidden={true}
                                                colorButton='blackButton'
                                                titleButton='Invoice Print'
                                                title='Invoice Print'
                                                companyLogo={getValueCookie('DocumentsLogo')}
                                                InvoiceType={this.state.addTitle + (this.state.Invoice.InvoiceType === 'IN' ? 'Invoice' : 'Credit Memo')}
                                                CompanyContactInfo={['Altitude LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', '(770) 871-5807']}
                                                InvoiceHeader={['Invoice Number:', this.state.Invoice.InvoiceNo, 'Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate), 'Grocer:', this.state.Invoice.SalespersonNo, 'Client No:', this.state.Invoice.Customer.CustomerNo, 'Batch No:', this.state.Invoice.BatchNo]}
                                                Box1={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                Box2={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(this.state.Invoice.Customer.TermsCode)]}
                                                DescriptionKeys={["quantityShipped", "itemCode", "upc", "abbreviatedDesc", "$", "UnitPrice", "$", "totalCost"]}
                                                HeaderDescritpion={["Qty", "Code", "SKU", "Description", "", "    Price", "", "Amount"]}
                                                StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormal", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                                Detail={this.printDetail()}
                                                breakpoint={45}
                                                quantSignDolar={this.realLongDetail()}
                                                keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                bottomInformation={[
                                                    NumberFormat(this.state.Invoice.TotalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)), "Net Invoice: ", "$", NumberFormat(pricesFormat(this.state.Invoice.TotalCost)),
                                                    "", "", "", "", "", "", "", "", "Freight: ", "$", NumberFormat(pricesFormat(this.state.Invoice.FreightAmt)),
                                                    "", "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.Invoice.FreightAmt) + Number(this.state.Invoice.TotalCost)))
                                                ]}
                                                bottomStyle={[
                                                    "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "LineButtom2Left", "DolarButtomLeft", "LineButtom2",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom2Left", "DolarButtomLeft", "LineButtom2",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom3Left", "DolarButtomLeft2", "LineButtom3",
                                                ]}
                                                bottomMessage={"Returned checks will incur an additional charge of $50.00. Los cheques rechazados tendran un cargo adicional de $50.00. \nNo Returns after 24 hours after delivered, No se aceptan devoluciones despues de 24 horas de entregado."}
                                                disabled={this.state.Products.length === 0}
                                            />
                                            :
                                            <DownloadInvoicePDF2InvoiceV3
                                                id={'InvoicePrint'}
                                                hidden={true}
                                                colorButton='blackButton'
                                                titleButton='Invoice Print'
                                                title='Invoice Print'
                                                companyLogo={getValueCookie('DocumentsLogo')}
                                                InvoiceType={this.state.addTitle + (this.state.Invoice.InvoiceType === 'IN' ? 'Invoice' : 'Credit Memo')}
                                                CompanyContactInfo={['Altitude LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', '(770) 871-5807']}
                                                InvoiceHeader={['Invoice Number:', this.state.Invoice.InvoiceNo, 'Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate), 'Grocer:', this.state.Invoice.SalespersonNo, 'Client No:', this.state.Invoice.Customer.CustomerNo, 'Batch No:', this.state.Invoice.BatchNo]}
                                                Box1={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                Box2={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(this.state.Invoice.Customer.TermsCode)]}
                                                DescriptionKeys={["quantityShipped", "itemCode", "upc", "abbreviatedDesc", "$", "UnitPrice", "$", "totalCost"]}
                                                HeaderDescritpion={["Quantity", "Code", "SKU", "Description", "", "    Price", "", "Amount"]}
                                                StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormal", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                                Detail={this.printDetail()}
                                                breakpoint={45}
                                                quantSignDolar={this.realLongDetail()}
                                                keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                bottomInformation={[
                                                    NumberFormat(this.state.Invoice.TotalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)), "Net Invoice: ", "$", NumberFormat(pricesFormat(this.state.Invoice.TotalCost)),
                                                    "", "", "", "", "", "", "", "", "Freight: ", "$", NumberFormat(pricesFormat(this.state.Invoice.FreightAmt)),
                                                    "", "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.Invoice.FreightAmt) + Number(this.state.Invoice.TotalCost)))
                                                ]}
                                                bottomStyle={[
                                                    "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "LineButtom2Left", "DolarButtomLeft", "LineButtom2",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom2Left", "DolarButtomLeft", "LineButtom2",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom3Left", "DolarButtomLeft2", "LineButtom3",
                                                ]}
                                                bottomMessage={"Returned checks will incur an additional charge of $50.00. Los cheques rechazados tendran un cargo adicional de $50.00. \nNo Returns after 24 hours after delivered, No se aceptan devoluciones despues de 24 horas de entregado."}
                                                docname={this.state.Invoice.InvoiceNo}
                                                disabled={this.state.Products.length === 0}
                                            />
                                    )
                                }
                            </div>
                            <div className='col-sm-12 col-md-5 d-grid gap-2'>
                                <button hidden={(this.state.Invoice.BatchNo ? false : (this.state.addTitle !== '' ? false : true))} disabled={this.state.Products.length === 0 || this.hasBlockingPrices()} title={this.blockingPriceMessage()} type="button" className="btn btn-outline-dark btn-lg" onClick={() => this.PrintAndSave("NoPrices")}><AiFillPrinter /> {this.state.addTitle !== 'REPRINT-' ? "Invoice Save and Print Without Prices" : "Invoice Print Without Prices"}</button>
                                {getValueCookie('CompanyId') !== '6' ?
                                    (
                                        MobileDisp() ?
                                            <InvoicePDFInvoiceV3
                                                id={'InvoiceWPrint'}
                                                hidden={true}
                                                colorButton='purpleButton'
                                                titleButton='Invoice Print Without Prices'
                                                title='Invoice Print'
                                                CompanyTitle='Mayaland'
                                                InvoiceType={this.state.addTitle + "Packing List"}
                                                CompanyContactInfo={['Mayaland LLC', '7055 Amwiler Industrial Dr', 'Suite B\n Atlanta, GA 30360', '(678) 213-1226']}
                                                InvoiceHeader={['Invoice Number:', this.state.Invoice.InvoiceNo, 'Invoice Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate), 'Sales Person:', this.state.Invoice.SalespersonNo, 'Customer Number:', this.state.Invoice.Customer.CustomerNo, 'Batch No:', this.state.Invoice.BatchNo]}
                                                Box1={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                Box2={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(this.state.Invoice.Customer.TermsCode)]}
                                                DescriptionKeys={["quantityShipped", "itemCode", "SKU", "abbreviatedDesc", "", "", "", ""]}
                                                HeaderDescritpion={["Qty", "Code", "SKU", "Description", "", "", "", ""]}
                                                StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormalCenter", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                                Detail={this.printDetail()}
                                                breakpoint={60}
                                                quantSignDolar={this.realLongDetail()}
                                                keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                bottomInformation={[
                                                    NumberFormat(this.state.Invoice.TotalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)), "", "", "",
                                                    "", "", "", "", "", "", "", "", "", "", "",
                                                    "", "", "", "", "", "", "", "", "", "", ""
                                                ]}
                                                bottomStyle={[
                                                    "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                ]}
                                                bottomMessage={"Comment:" + this.state.Invoice.Comment}
                                                disabled={this.state.Products.length === 0}
                                            />
                                            :
                                            <DownloadInvoicePDFInvoiceV3
                                                id={'InvoiceWPrint'}
                                                hidden={true}
                                                colorButton='purpleButton'
                                                titleButton='Invoice Print Without Prices'
                                                title='Invoice Print'
                                                CompanyTitle='Mayaland'
                                                InvoiceType={this.state.addTitle + "Packing List"}
                                                CompanyContactInfo={['Mayaland LLC', '7055 Amwiler Industrial Dr', 'Suite B\n Atlanta, GA 30360', '(678) 213-1226']}
                                                InvoiceHeader={['Invoice Number:', this.state.Invoice.InvoiceNo, 'Invoice Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate), 'Sales Person:', this.state.Invoice.SalespersonNo, 'Customer Number:', this.state.Invoice.Customer.CustomerNo, 'Batch No:', this.state.Invoice.BatchNo]}
                                                Box1={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                Box2={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(this.state.Invoice.Customer.TermsCode)]}
                                                DescriptionKeys={["quantityShipped", "itemCode", "SKU", "abbreviatedDesc", "", "", "", ""]}
                                                HeaderDescritpion={["Qty", "Code", "SKU", "Description", "", "", "", ""]}
                                                StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormalCenter", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                                Detail={this.printDetail()}
                                                breakpoint={60}
                                                quantSignDolar={this.realLongDetail()}
                                                keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                bottomInformation={[
                                                    NumberFormat(this.state.Invoice.TotalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)), "", "", "",
                                                    "", "", "", "", "", "", "", "", "", "", "",
                                                    "", "", "", "", "", "", "", "", "", "", ""
                                                ]}
                                                bottomStyle={[
                                                    "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                ]}
                                                bottomMessage={"Comment:" + this.state.Invoice.Comment}
                                                docname={"Packing List " + this.state.Invoice.InvoiceNo}
                                                disabled={this.state.Products.length === 0}
                                            />
                                    )
                                    :
                                    (
                                        MobileDisp() ?
                                            <InvoicePDF2InvoiceV3
                                                id={'InvoiceWPrint'}
                                                hidden={true}
                                                colorButton='purpleButton'
                                                titleButton='Invoice Print Without Prices'
                                                title='Invoice Print'
                                                companyLogo={getValueCookie('DocumentsLogo')}
                                                InvoiceType={this.state.addTitle + "Packing List"}
                                                CompanyContactInfo={['Altitude LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', 'Atlanta, GA 30360', '(770) 871-5807']}
                                                InvoiceHeader={['Invoice Number:', this.state.Invoice.InvoiceNo, 'Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate), 'Grocer:', this.state.Invoice.SalespersonNo, 'Client No:', this.state.Invoice.Customer.CustomerNo, 'Batch No:', this.state.Invoice.BatchNo]}
                                                Box1={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                Box2={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", "Pay in Advance"]}
                                                DescriptionKeys={["quantityShipped", "itemCode", "upc", "abbreviatedDesc", "", "", "", ""]}
                                                HeaderDescritpion={["Qty", "Code", "SKU", "Description", "", "", "", ""]}
                                                StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormal", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                                Detail={this.printDetail()}
                                                breakpoint={45}
                                                quantSignDolar={this.realLongDetail()}
                                                keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                bottomInformation={[
                                                    NumberFormat(this.state.Invoice.TotalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)), "", "", "",
                                                    "", "", "", "", "", "", "", "", "", "", "",
                                                    "", "", "", "", "", "", "", "", "", "", ""
                                                ]}
                                                bottomStyle={[
                                                    "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                ]}
                                                bottomMessage={""}
                                                disabled={this.state.Products.length === 0}
                                            />
                                            :
                                            <DownloadInvoicePDF2InvoiceV3
                                                id={'InvoiceWPrint'}
                                                hidden={true}
                                                colorButton='purpleButton'
                                                titleButton='Invoice Print Without Prices'
                                                title='Invoice Print'
                                                companyLogo={getValueCookie('DocumentsLogo')}
                                                InvoiceType={this.state.addTitle + "Packing List"}
                                                CompanyContactInfo={['Altitude LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', 'Atlanta, GA 30360', '(770) 871-5807']}
                                                InvoiceHeader={['Invoice Number:', this.state.Invoice.InvoiceNo, 'Date:', DateFormatMAS90(this.state.Invoice.InvoiceDate), 'Grocer:', this.state.Invoice.SalespersonNo, 'Client No:', this.state.Invoice.Customer.CustomerNo, 'Batch No:', this.state.Invoice.BatchNo]}
                                                Box1={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                Box2={[this.state.Invoice.Customer.CustomerName, this.state.Invoice.Customer.AddressLine1, this.state.Invoice.Customer.City + ", " + this.state.Invoice.Customer.State + " " + this.state.Invoice.Customer.ZipCode]}
                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", "Pay in Advance"]}
                                                DescriptionKeys={["quantityShipped", "itemCode", "upc", "abbreviatedDesc", "", "", "", ""]}
                                                HeaderDescritpion={["Quantity", "Code", "SKU", "Description", "", "", "", ""]}
                                                StyleDetail={["ColumnaCantidades", "ColumnaNormal", "ColumnaNormal", "ColumnaGrande", "Simbolo", "ColumnaMonetaria", "Simbolo", "ColumnaMonetariaRight"]}
                                                Detail={this.printDetail()}
                                                breakpoint={45}
                                                quantSignDolar={this.realLongDetail()}
                                                keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                bottomInformation={[
                                                    NumberFormat(this.state.Invoice.TotalQuantityShipped), "", "Cash", "", "Check", "", "", "Open     Weight: " + NumberFormat(pricesFormat(this.state.Invoice.TotalWeight)), "", "", "",
                                                    "", "", "", "", "", "", "", "", "", "", "",
                                                    "", "", "", "", "", "", "", "", "", "", ""
                                                ]}
                                                bottomStyle={[
                                                    "NormalButtom", "CheckButtom", "NormalButtom", "CheckButtom", "NormalButtom", "LineButtom", "CheckButtom", "LargeButtom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                ]}
                                                bottomMessage={""}
                                                docname={"Packing List " + this.state.Invoice.InvoiceNo}
                                                disabled={this.state.Products.length === 0}
                                            />
                                    )
                                }

                            </div>
                        </div>
                    </div>

                    
                </div>

                {/* Modals */}
                <SmallModal backdrop={'static'} centered={true} size={'md'} title={'New Batch Number'} show={this.state.showModal1}  close={(modal = "showModal1") => this.cancelWithBatchNo(modal)}>
                    <div className='row'>
                        <div className="col-sm-12 pt-1 input-group input-group-lg flex-nowrap">
                            <input className="form-control form-control-lg text-center" defaultValue={this.state.Invoice.BatchNo} id='batchNoInputInvoice' type="text" placeholder='Batch Number' onChange={(e) => this.onTarget(e, '')} />
                            <span className="input-group-text">
                                <div className='d-grid gap-2'>
                                    <button type="button" className="btn yellowButton btn-lg" onClick={() => this.getNewCorrelativeBatchNumber()}>Generate Batch</button>
                                </div>
                            </span>
                        </div>

                    </div>
                    <div className='row pt-3'>
                        <div className='col-sm-6 pb-2 d-grid gap-2'>
                            <button type="button" disabled={this.state.temporalBatchNo === ''} className="btn greenButton btn-lg" onClick={() => this.ConfirmBatchNumber()}>Accept</button>
                        </div>
                        <div className='col-sm-6 pb-2 d-grid gap-2'>
                            <button type="button" className="btnSecondaryCustom btn-lg" onClick={() => this.cancelWithBatchNo('showModal1')}>Cancel</button>
                        </div>
                    </div>
                </SmallModal>
                <SmallModal centered={false} size={'xl'} title={'Balance: ' + this.state.Invoice.Customer.CustomerName} show={this.state.showModal2} close={(modal = "showModal2") => this.handleModalClose(modal)}>
                    <div className='row pt-2'>
                        <div className='col-sm-12 pb-2'>
                            <h3>Terms Code: {this.state.Balance.TermsCode}</h3>
                        </div>
                        <div className='col-sm-12 tableFixHead'>
                            <table className='table table-hover text-center'>
                                <thead className='table-dark thead'>
                                    <tr>
                                        <th>Invoice No</th>
                                        <th>Date</th>
                                        <th>Due Date</th>
                                        <th>Payment Delay Days</th>
                                        <th>Customer Name</th>
                                        <th>Sales Person</th>
                                        <th></th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.Balance.HeaderBalance.map((element, e) => (
                                            <tr className={element.InvoiceNo === this.state.Balance.SelectedInvoice ? 'bg-warning' : ''} onClick={() => this.getDetailBalance(element)} key={e}>
                                                <td>{element.InvoiceNo}</td>
                                                <td>{element.InvoiceDate}</td>
                                                <td>{element.InvoiceDueDate}</td>
                                                <td>{element.PaymentDelayDays}</td>
                                                <td>{this.state.Invoice.Customer.CustomerName}</td>
                                                <td>{element.SalespersonNo}</td>
                                                <td>$</td>
                                                <td className='text-end'>{pricesFormat(element.Balance)}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot className='tfoot'>
                                    <tr className='table-dark'>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>TOTAL:</td>
                                        <td>$</td>
                                        <td className='text-end'>{pricesFormat(this.state.Balance.TotalBalance)}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div className='col-sm-12'>
                            <h3 className='text-start'>Detail: {this.state.Balance.SelectedInvoice}</h3>
                        </div>
                        <div className='col-sm-12 tableFixHead'>
                            <table className='table table-hover text-center'>
                                <thead className='table-dark thead'>
                                    <tr>
                                        <th>Invoice No</th>
                                        <th>Invoice Type</th>
                                        <th>Transaction Type</th>
                                        <th>Transaction Date</th>
                                        <th></th>
                                        <th>Transaction Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.Balance.Detail.map((element, e) => (
                                            <tr key={e}>
                                                <td>{element.InvoiceNo}</td>
                                                <td>{element.InvoiceType}</td>
                                                <td>{element.TransactionType}</td>
                                                <td>{DateFormatMAS90(element.TransactionDate)}</td>
                                                <td className='text-end'>$</td>
                                                <td className='text-end'>{pricesFormat(element.TransactionAmt)}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot className='tfoot'>
                                </tfoot>
                            </table>
                        </div>



                        <div className='col-sm-6 pt-2'>
                            <OrderPDF id={"CurrentBalancePrintSalesOrder"} colorButton="blackButton" title="Sales Order Print"
                                companyLogo={getValueCookie('DocumentsLogo')}
                                OrderTitle="Current Balance"
                                contactInfo={this.state.companyPrintHeader}
                                OrderInfo1={[
                                    "Customer No:", this.state.Invoice.Customer.CustomerNo, "Print By:", getValueCookie('userName'),
                                    "Customer Name:", this.state.Invoice.Customer.CustomerName, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                    "Phone:", this.state.Invoice.Customer.TelephoneNo, "Terms Code:", this.state.Balance.TermsCode,
                                    "Address:", this.state.Invoice.Customer.AddressLine1, "", "",
                                    "City", this.state.Invoice.Customer.City, "", ""
                                ]}
                                headerTable={["Invoice No", "Date", "Due\nDate", "Payment Delay Days", "Customer\nName", "Sales\nPerson", "", "Balance"]}
                                bodyTable={this.state.Balance.HeaderBalance}
                                headerBodyTable={["InvoiceNo", "InvoiceDate", "InvoiceDueDate", "PaymentDelayDays", "CustomerName", "SalespersonNo", "dolar", "Balance"]}
                                bottomInfo={["", "", "", "", "", "TOTAL", "$", pricesFormat(this.state.Balance.TotalBalance)]}
                                styleColumns={["ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaCantidades", "ColumnaTextoLargo2", "ColumnaCantidades", "Dolar", "ColumnaPrecios"]}
                                hidden={false}
                                comment={""}
                                keysDecimalFormat={["Balance"]}
                                breakpoint={28}
                                disabled={false}
                                titleButton='Print Balance'
                            />
                        </div>
                        <div className='col-sm-6 pt-2'>
                            <div className="d-grid gap-2">
                                <button type="button" onClick={() => this.handleModalClose("showModal2")} className="btn redButton btn-lg">Close</button>
                            </div>
                        </div>
                    </div>

                </SmallModal>
            </div>
        )
    }
}